import React from 'react';

const icons = {
  paymentIcon: (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_78_357)">
        <path
          d="M30.8499 43.0534C30.4669 43.0541 30.1022 42.886 29.8537 42.5944L22.9349 34.4923C22.4649 33.9419 22.53 33.1153 23.0803 32.6453C23.6307 32.176 24.4574 32.2411 24.9273 32.7907L31.0151 39.92L46.1354 27.6188C46.6967 27.162 47.5219 27.2468 47.978 27.8081C48.4348 28.3695 48.35 29.1947 47.7887 29.6507L31.6751 42.7596C31.4427 42.9496 31.151 43.0534 30.8499 43.0534Z"
          fill="#2DE1C2"
        />
        <path
          d="M30.4179 68.3437L33.9687 69.891C34.3005 70.0357 34.6784 70.0364 35.011 69.8924L39.012 68.1646C53.06 62.2647 62.1993 48.5148 62.2008 33.2783V15.3294C62.2008 14.8455 61.934 14.4004 61.5071 14.1731L35.1981 0.154245C34.8078 -0.0540638 34.34 -0.0511404 33.9526 0.161554L8.37155 14.1804C7.95201 14.4106 7.6918 14.8506 7.6918 15.3294V33.6416C7.70715 48.6946 16.6257 62.3129 30.4179 68.3437ZM10.3114 16.1049L34.5907 2.79794L59.5812 16.1144V33.2783C59.5783 47.4645 51.0668 60.2649 37.9865 65.7548L37.977 65.7592L34.4935 67.2634L31.4661 65.9426C18.6277 60.3292 10.3253 47.6538 10.3106 33.6416L10.3114 16.1049Z"
          fill="#087ACB"
        />
        <path
          d="M43.5999 58.2695L43.5911 58.2732L40.1069 59.7781L37.0794 58.4581C24.241 52.8447 15.9386 40.1693 15.924 26.157V13.0284L10.3106 16.1048V33.6415C10.3253 47.6538 18.6276 60.3292 31.4661 65.9426L34.4928 67.2626L37.977 65.7577L37.9858 65.754C45.2364 62.701 51.2613 57.3171 55.1066 50.4546C51.8248 53.7934 47.9137 56.4495 43.5999 58.2695Z"
          fill="#E5F0FD"
        />
      </g>
      <defs>
        <clipPath id="clip0_78_357">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  cross: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M13 1L1 13M1 1L13 13"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  toolsIcon: (
    <svg
      version="1.0"
      xmlns="http://www.w3.org/2000/svg"
      width="13.000000pt"
      height="13.000000pt"
      viewBox="0 0 512.000000 512.000000"
    >
      <g
        transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)"
        fill="#000000"
        stroke="none"
      >
        <path
          d="M521 4784 c-169 -45 -301 -180 -346 -351 -23 -87 -22 -2520 0 -2608
45 -172 179 -305 352 -350 47 -12 150 -15 588 -15 l532 0 33 -102 c40 -122
116 -274 190 -384 71 -103 273 -305 379 -379 392 -273 888 -346 1346 -198 113
36 265 111 376 184 116 78 313 271 394 388 119 171 211 392 252 606 25 129 24
396 -1 530 -59 319 -194 575 -425 806 -185 184 -369 299 -603 375 l-88 28 0
531 c0 438 -3 541 -15 588 -45 173 -178 307 -350 352 -86 22 -2530 22 -2614
-1z m2585 -330 c15 -11 37 -33 48 -48 20 -27 21 -40 24 -535 l3 -508 -128 -6
c-380 -20 -712 -163 -981 -421 -290 -279 -448 -628 -469 -1029 l-6 -128 -508
3 c-495 3 -508 4 -535 24 -15 11 -37 33 -48 48 -21 27 -21 33 -24 1249 -1 672
0 1236 3 1254 7 40 49 91 90 109 24 11 254 13 1267 11 1232 -2 1237 -2 1264
-23z m274 -1443 c414 -94 750 -400 879 -799 44 -136 56 -215 56 -372 0 -157
-12 -236 -56 -372 -131 -405 -475 -713 -899 -804 -106 -23 -352 -26 -455 -5
-485 96 -857 460 -961 941 -14 62 -18 127 -18 240 0 224 36 375 138 566 170
320 497 557 846 614 41 6 82 13 90 15 42 11 302 -6 380 -24z"
        />
        <path
          d="M3097 2566 c-42 -15 -72 -39 -90 -71 -8 -13 -14 -107 -17 -265 l-5
-245 -245 -5 c-266 -5 -271 -6 -316 -65 -58 -77 -32 -188 56 -232 42 -22 55
-23 277 -23 l233 0 0 -243 c0 -240 0 -243 24 -278 66 -96 218 -88 274 14 14
27 17 67 20 270 l4 237 227 0 c215 0 229 1 271 23 111 55 119 195 16 271 -26
20 -43 21 -272 24 l-244 3 0 222 c-1 231 -7 275 -47 319 -41 46 -110 64 -166
44z"
        />
      </g>
    </svg>
  ),
  calendar: (
    <svg width="20" height="22" viewBox="0 0 20 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19 9H1M14 1V5M6 1V5M5.8 21H14.2C15.8802 21 16.7202 21 17.362 20.673C17.9265 20.3854 18.3854 19.9265 18.673 19.362C19 18.7202 19 17.8802 19 16.2V7.8C19 6.11984 19 5.27976 18.673 4.63803C18.3854 4.07354 17.9265 3.6146 17.362 3.32698C16.7202 3 15.8802 3 14.2 3H5.8C4.11984 3 3.27976 3 2.63803 3.32698C2.07354 3.6146 1.6146 4.07354 1.32698 4.63803C1 5.27976 1 6.11984 1 7.8V16.2C1 17.8802 1 18.7202 1.32698 19.362C1.6146 19.9265 2.07354 20.3854 2.63803 20.673C3.27976 21 4.11984 21 5.8 21Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  calendarIcon: (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M38.8036 47.7687H13.2216C10.0163 47.7659 7.41815 45.1775 7.41533 41.9836V8.41123C7.41533 8.14206 7.43465 7.87288 7.47237 7.60699C4.60788 8.01099 2.47742 10.4519 2.47412 13.3344V46.9076C2.47742 50.1011 5.07508 52.6886 8.27948 52.6923H40.3117L38.8036 47.7687Z"
        fill="#E5F0FD"
      />
      <path
        d="M55.563 13.3762V33.6363C54.8652 33.516 54.1595 33.4479 53.4514 33.4319V20.6407H4.28402V46.2303C4.28732 48.9676 6.51395 51.1854 9.26105 51.1896H38.7192C38.8729 51.9055 39.0818 52.6087 39.3439 53.2932H9.26105C5.34807 53.288 2.17761 50.1288 2.17242 46.2303V13.3762C2.17714 9.47668 5.34807 6.3175 9.26105 6.31281H48.4743C52.3873 6.31703 55.5587 9.47668 55.563 13.3762ZM53.4514 18.5366V13.3762C53.4485 10.6389 51.2219 8.41971 48.4743 8.41689H9.26105C6.51395 8.42018 4.28732 10.6389 4.28402 13.3762V18.5366H53.4514Z"
        fill="#087ACB"
      />
      <path
        d="M55.5629 33.6362C54.8651 33.516 54.1594 33.4479 53.4513 33.4319C53.3325 33.4281 53.2113 33.4272 53.0906 33.4272C52.5074 33.4272 52.035 33.8979 52.035 34.479C52.035 35.0601 52.5074 35.5313 53.0906 35.5313C53.5248 35.5313 53.9533 35.5533 54.3772 35.5956C60.6318 36.2378 65.4533 41.3784 65.6734 47.64C65.8941 53.9015 61.4465 59.3663 55.2526 60.4444C49.0588 61.522 43.0158 57.8837 41.0928 51.9181C40.9637 51.5165 40.8552 51.1092 40.7689 50.6963H42.6792C43.0649 50.6958 43.4194 50.4867 43.6052 50.1499C43.79 49.8136 43.7763 49.403 43.5698 49.0789L40.5186 44.3065C40.3244 44.0026 39.9887 43.8189 39.6276 43.8189C39.2669 43.8189 38.9313 44.0026 38.7375 44.3065L35.6863 49.0789C35.4789 49.403 35.4661 49.814 35.6514 50.1509C35.8372 50.4872 36.1917 50.6963 36.5778 50.6963H38.6215C38.6512 50.8612 38.6828 51.027 38.7191 51.1895C38.8728 51.9054 39.0816 52.6087 39.3438 53.2931C41.8754 59.9253 48.8118 63.7966 55.8104 62.4846C62.808 61.1721 67.8576 55.0529 67.7968 47.9571C67.736 40.8617 62.5822 34.829 55.5629 33.6362ZM38.5018 48.5922L39.629 46.8296L40.7553 48.5922H38.5018Z"
        fill="#2DE1C2"
      />
      <path
        d="M52.3745 40.6033C51.7908 40.6033 51.3184 41.074 51.3184 41.6551V49.153C51.3184 49.7337 51.7908 50.2048 52.3745 50.2048H58.1072C58.6899 50.2048 59.1628 49.7337 59.1628 49.153C59.1628 48.5719 58.6899 48.1007 58.1072 48.1007H53.43V41.6551C53.4295 41.0744 52.9572 40.6037 52.3745 40.6033Z"
        fill="#2DE1C2"
      />
      <path
        d="M25.8327 10.613H25.8242C24.1944 10.6098 22.8711 11.9242 22.8687 13.5481C22.8659 15.1726 24.185 16.4908 25.8152 16.4931H25.8242C27.4493 16.4917 28.7679 15.182 28.7754 13.5627C28.7797 11.9392 27.4629 10.6187 25.8327 10.613ZM25.8242 14.3895H25.8223C25.3594 14.3881 24.9841 14.0123 24.9855 13.5505C24.9874 13.0901 25.3622 12.7176 25.8242 12.7167H25.827C26.2905 12.7176 26.6657 13.0925 26.6648 13.5547C26.6643 14.0165 26.2876 14.39 25.8242 14.3895Z"
        fill="#2DE1C2"
      />
      <path
        d="M17.3208 10.5872H17.3114C15.6821 10.5848 14.3587 11.8992 14.3564 13.5227C14.354 15.1467 15.6731 16.4649 17.3029 16.4672H17.3114C18.9369 16.4649 20.256 15.1552 20.2631 13.5359V13.5265C20.2612 11.9067 18.9464 10.5933 17.3208 10.5872ZM17.3114 14.3636H17.3086C16.8451 14.3627 16.4703 13.9878 16.4708 13.5255C16.4713 13.0638 16.848 12.6903 17.3114 12.6908H17.3147C17.7781 12.6922 18.1529 13.068 18.1515 13.5293C18.1492 13.9901 17.7739 14.3627 17.3114 14.3636Z"
        fill="#2DE1C2"
      />
      <path
        d="M8.80844 10.5599H8.79948C7.1697 10.5576 5.84683 11.872 5.844 13.496C5.84164 15.1195 7.16074 16.4381 8.79005 16.4405H8.79948C10.4245 16.4386 11.7422 15.1289 11.7493 13.5101V13.4993C11.7484 11.8805 10.434 10.5665 8.80844 10.5599ZM8.79948 14.3364H8.79665C8.33322 14.3359 7.95795 13.9606 7.95842 13.4988C7.95937 13.0365 8.33605 12.6626 8.79948 12.664H8.80278C9.26621 12.6645 9.64101 13.0398 9.64054 13.5016C9.63912 13.9639 9.26291 14.3378 8.79948 14.3364Z"
        fill="#2DE1C2"
      />
    </svg>
  ),
  professionalIcon: (
    <svg width="70" height="70" viewBox="0 0 70 70" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_78_340)">
        <path
          d="M33.3725 17.4845C33.2745 17.5198 33.1844 17.5741 33.1073 17.6443C33.0302 17.7144 32.9677 17.799 32.9234 17.8934C32.879 17.9877 32.8537 18.0898 32.8488 18.1939C32.8439 18.298 32.8596 18.402 32.8949 18.5001C32.9367 18.616 33.9474 21.3744 36.5359 24.4363C36.6722 24.5956 36.8659 24.6945 37.0749 24.7114C37.2838 24.7283 37.491 24.6618 37.6511 24.5264C37.8111 24.3911 37.9112 24.1979 37.9293 23.9891C37.9474 23.7802 37.8822 23.5727 37.7478 23.4118C35.3551 20.5817 34.3969 17.9871 34.3877 17.9612C34.3162 17.7634 34.1691 17.6022 33.9787 17.5128C33.7884 17.4234 33.5704 17.4133 33.3725 17.4845Z"
          fill="#087ACB"
        />
        <path
          d="M48.8662 49.2731H39.4106V45.2504C40.8041 44.2625 41.9399 42.9542 42.7224 41.4357C43.5049 39.9173 43.9111 38.233 43.907 36.5248V35.4298C43.907 35.4827 44.1262 35.5371 44.2536 35.5898C44.3445 35.6298 44.4428 35.6505 44.5421 35.6505C44.6981 35.6504 44.8506 35.6037 44.9798 35.5164C45.1091 35.4291 45.2094 35.3052 45.2679 35.1606C45.3478 34.9656 45.347 34.747 45.2658 34.5526C45.1846 34.3582 45.0296 34.204 44.8348 34.1238C37.5437 31.1034 33.6836 27.0535 31.7313 24.1878C29.6316 21.1065 29.2217 18.6939 29.2137 18.645C29.1818 18.4369 29.0685 18.2499 28.8988 18.1254C28.7291 18.0008 28.5168 17.9487 28.3087 17.9806C28.1006 18.0125 27.9137 18.1258 27.7891 18.2955C27.6645 18.4653 27.6124 18.6775 27.6443 18.8857C27.6589 18.9807 27.975 20.9529 29.5332 23.6686C28.0588 24.0357 26.6601 24.6584 25.4007 25.5084C24.4746 26.13 23.6976 26.9488 23.1252 27.9061C22.5529 28.8633 22.1995 29.9354 22.0903 31.0453C22.021 31.0515 21.9454 31.0613 21.8773 31.0728C21.5798 30.2198 21.4269 29.323 21.4251 28.4196V26.6628C21.4251 23.4185 22.7139 20.307 25.008 18.0129C27.3021 15.7188 30.4135 14.43 33.6579 14.43C36.9022 14.43 40.0137 15.7188 42.3078 18.0129C44.6019 20.307 45.8907 23.4185 45.8907 26.6628V27.5256C45.8907 27.736 45.9743 27.9378 46.1231 28.0867C46.2719 28.2355 46.4737 28.3191 46.6841 28.3191C46.8946 28.3191 47.0964 28.2355 47.2452 28.0867C47.394 27.9378 47.4776 27.736 47.4776 27.5256V26.6628C47.481 24.2597 46.8578 21.8973 45.6695 19.8086C44.4812 17.7198 42.7688 15.9771 40.7013 14.7522C40.7532 14.4188 40.7816 14.0822 40.7862 13.7448C40.7862 12.8119 40.6025 11.8881 40.2454 11.0262C39.8884 10.1643 39.3651 9.38112 38.7055 8.72144C38.0458 8.06176 37.2626 7.53847 36.4007 7.18146C35.5388 6.82444 34.615 6.64069 33.6821 6.64069C32.7491 6.64069 31.8253 6.82444 30.9634 7.18146C30.1015 7.53847 29.3184 8.06176 28.6587 8.72144C27.999 9.38112 27.4757 10.1643 27.1187 11.0262C26.7617 11.8881 26.5779 12.8119 26.5779 13.7448C26.577 14.0816 26.5998 14.418 26.646 14.7515C24.5744 15.9746 22.8572 17.7162 21.6634 19.8049C20.4696 21.8935 19.8405 24.2571 19.8381 26.6628V28.4196C19.839 29.6064 20.0581 30.783 20.4844 31.8906C20.4192 32.0509 20.4083 32.2282 20.4533 32.3953C20.4983 32.5624 20.5967 32.7101 20.7336 32.816C20.8705 32.9219 21.0383 32.98 21.2113 32.9816C21.3844 32.9831 21.5532 32.928 21.6919 32.8246C21.8794 32.6863 22.106 32.6112 22.339 32.6101H22.8443C22.9483 32.6106 23.0513 32.5907 23.1475 32.5513C23.2437 32.512 23.3311 32.454 23.4049 32.3808C23.4786 32.3075 23.5371 32.2204 23.5771 32.1245C23.6171 32.0286 23.6377 31.9257 23.6378 31.8217C23.633 30.8353 23.8719 29.863 24.3333 28.9912C24.7947 28.1193 25.4644 27.375 26.2827 26.8243C27.5461 25.9766 28.9655 25.3886 30.4582 25.0944C32.3638 27.8853 35.8399 31.6761 42.32 34.7154V36.5246C42.32 38.9973 41.3377 41.3687 39.5893 43.1172C37.8408 44.8657 35.4693 45.8479 32.9966 45.8479C30.5239 45.8479 28.1525 44.8657 26.404 43.1172C24.6555 41.3687 23.6732 38.9973 23.6732 36.5246V35.616C23.6732 35.1779 23.2826 34.8582 22.8443 34.8582H22.339C22.283 34.8523 22.2275 34.8422 22.1729 34.8281C22.0704 34.8116 21.9656 34.8155 21.8646 34.8396C21.7637 34.8638 21.6685 34.9077 21.5845 34.9689C21.5006 35.03 21.4296 35.1072 21.3757 35.1959C21.3217 35.2846 21.2859 35.3831 21.2702 35.4858C21.2428 35.6954 21.2993 35.9073 21.4274 36.0755C21.5554 36.2437 21.7447 36.3546 21.954 36.384C21.9974 36.3936 22.0419 36.397 22.0863 36.3942V36.5248C22.0863 40.3055 23.9377 43.6415 26.9794 45.5969V49.2731H17.5244C16.4544 49.274 15.395 49.4859 14.4069 49.8966C13.4188 50.3073 12.5213 50.9088 11.7659 51.6666C11.0104 52.4245 10.4118 53.3238 10.0042 54.3132C9.59667 55.3026 9.38816 56.3627 9.39063 57.4327V68.557C9.38654 68.6607 9.40298 68.7641 9.43901 68.8614C9.47504 68.9587 9.52995 69.0478 9.60056 69.1238C9.67118 69.1998 9.75613 69.2611 9.85051 69.3041C9.94489 69.3471 10.0468 69.3711 10.1505 69.3746H56.2395C56.3432 69.3711 56.4452 69.3471 56.5396 69.3041C56.634 69.261 56.719 69.1997 56.7896 69.1236C56.8602 69.0476 56.9151 68.9583 56.9511 68.861C56.9871 68.7637 57.0035 68.6602 56.9994 68.5565V57.4327C57.0018 56.3627 56.7933 55.3027 56.3858 54.3134C55.9783 53.324 55.3797 52.4247 54.6243 51.6669C53.869 50.909 52.9716 50.3075 51.9836 49.8968C50.9955 49.4861 49.9362 49.2741 48.8662 49.2731ZM33.6899 8.22288C35.154 8.22435 36.5577 8.80659 37.593 9.84183C38.6283 10.8771 39.2106 12.2807 39.2122 13.7448C39.2122 13.821 39.2097 13.8972 39.2065 13.9734C37.4662 13.216 35.5886 12.8252 33.6906 12.8252C31.7926 12.8252 29.915 13.216 28.1747 13.9734C28.1716 13.8973 28.1683 13.8213 28.1683 13.7451C28.1698 12.2811 28.752 10.8775 29.7872 9.8422C30.8223 8.80693 32.2259 8.22456 33.6899 8.22288ZM28.5664 46.4721C30.0265 47.1364 31.6185 47.4603 33.2221 47.4194C34.8257 47.3786 36.3991 46.9741 37.8236 46.2365V50.0798L36.7392 55.3932C34.4492 56.2578 31.9227 56.2589 29.632 55.3963L28.5664 50.0805V46.4721ZM17.0609 67.7876V65.5394C17.0609 65.329 16.9773 65.1272 16.8285 64.9784C16.6797 64.8296 16.4779 64.746 16.2674 64.746C16.057 64.746 15.8552 64.8296 15.7064 64.9784C15.5576 65.1272 15.474 65.329 15.474 65.5394V67.7876H10.9776V57.4327C10.9745 56.4953 11.1726 55.5681 11.5585 54.7137C11.9445 53.8594 12.5094 53.0979 13.2149 52.4806C14.6886 54.4195 15.4826 56.7898 15.474 59.2252V60.2496C15.474 60.46 15.5576 60.6618 15.7064 60.8106C15.8552 60.9595 16.057 61.0431 16.2674 61.0431C16.4779 61.0431 16.6797 60.9595 16.8285 60.8106C16.9773 60.6618 17.0609 60.46 17.0609 60.2496V59.2251C17.0663 56.4699 16.1737 53.7881 14.5185 51.5856C15.448 51.1067 16.4788 50.8579 17.5244 50.8601H27.0462L30.5802 67.7876H17.0609ZM32.2009 67.7876L29.9908 57.1993C32.0851 57.7831 34.299 57.7835 36.3935 57.2005L34.1736 67.7876H32.2009ZM49.1968 67.7876H35.7952L39.3445 50.8601H48.8662C49.8542 50.8577 50.8295 51.0823 51.7169 51.5165C50.0893 53.6994 49.2059 56.3473 49.1968 59.0702V67.7876ZM55.4124 67.7876H50.7838V59.0702C50.7865 56.6536 51.5767 54.3036 53.0347 52.3764C53.7782 52.9928 54.3767 53.7654 54.7876 54.6393C55.1986 55.5133 55.4119 56.467 55.4124 57.4327V67.7876Z"
          fill="#087ACB"
        />
        <path
          d="M20.2348 56.4221C20.4452 56.4221 20.647 56.3385 20.7958 56.1897C20.9446 56.0409 21.0282 55.8391 21.0282 55.6286V54.7955C21.0282 54.585 20.9446 54.3832 20.7958 54.2344C20.647 54.0856 20.4452 54.002 20.2348 54.002C20.0243 54.002 19.8225 54.0856 19.6737 54.2344C19.5249 54.3832 19.4413 54.585 19.4413 54.7955V55.6286C19.4413 55.8391 19.5249 56.0409 19.6737 56.1897C19.8225 56.3385 20.0243 56.4221 20.2348 56.4221Z"
          fill="#087ACB"
        />
        <path
          d="M20.2348 65.0181C20.4452 65.0181 20.647 64.9345 20.7958 64.7857C20.9446 64.6369 21.0282 64.4351 21.0282 64.2247V58.1413C21.0282 57.9309 20.9446 57.729 20.7958 57.5802C20.647 57.4314 20.4452 57.3478 20.2348 57.3478C20.0243 57.3478 19.8225 57.4314 19.6737 57.5802C19.5249 57.729 19.4413 57.9309 19.4413 58.1413V64.2247C19.4413 64.4351 19.5249 64.6369 19.6737 64.7857C19.8225 64.9345 20.0243 65.0181 20.2348 65.0181Z"
          fill="#087ACB"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M61.8194 9.81178C62.0135 9.81691 62.1958 9.88517 62.3357 10.0163L63.0128 10.6685C63.3289 10.9723 63.2881 11.5025 62.9224 11.8552L56.9759 17.572C56.687 17.8499 56.1407 17.8698 55.8293 17.572L53.0788 14.9264C52.7131 14.5742 52.6743 14.0446 52.9901 13.7414L53.6655 13.0897C53.9833 12.7859 54.5339 12.8229 54.8994 13.1736L56.4025 14.6197L61.0998 10.1031C61.3075 9.90537 61.571 9.80638 61.8194 9.81178ZM60.4093 3.45644C60.0211 3.44307 59.612 3.5432 59.1969 3.75767C58.288 4.22757 57.6019 4.13114 56.8029 3.75767C56.3831 3.56112 55.9694 3.46327 55.584 3.47436C54.9401 3.49427 54.3669 3.82423 53.9382 4.51202C53.3948 5.38412 52.7419 5.60314 51.8634 5.69246C50.6007 5.81847 49.7973 6.50142 49.7629 7.75866C49.7358 8.78096 49.2828 9.29097 48.5666 9.80098C47.5373 10.5326 47.1915 11.5176 47.7993 12.6244C48.2942 13.5221 48.1622 14.1854 47.7993 14.9799C47.2802 16.1222 47.4761 17.1442 48.5666 17.8033C49.4498 18.3389 49.6725 18.9783 49.7629 19.8453C49.8921 21.0886 50.5863 21.8779 51.8634 21.9132C52.9 21.9422 53.4208 22.3848 53.9382 23.0916C54.7055 24.1432 55.6609 24.4305 56.8029 23.8488C57.7227 23.3815 58.3917 23.481 59.1969 23.8488C60.3614 24.3833 61.2974 24.1432 62.0632 23.0916C62.5806 22.3851 63.1015 21.9422 64.138 21.9132C65.4155 21.8782 66.1094 21.0889 66.2385 19.8453C66.329 18.9783 66.5517 18.3389 67.4348 17.8033C68.5242 17.1445 68.723 16.1222 68.2021 14.9799C67.8393 14.1854 67.7084 13.5221 68.2021 12.6244C68.8114 11.5176 68.4656 10.5326 67.4348 9.80098C66.7172 9.29097 66.2674 8.78096 66.2385 7.75866C66.2053 6.50142 65.4008 5.81875 64.138 5.69246C63.2578 5.60314 62.6078 5.38412 62.0632 4.51202C61.636 3.82423 61.0536 3.4792 60.4093 3.45644Z"
          fill="#2DE1C2"
        />
      </g>
      <defs>
        <clipPath id="clip0_78_340">
          <rect width="70" height="70" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  tiltedArrow: (
    <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15.8335 2.9165L4.16683 14.5832"
        stroke="#2E95BF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M15.8335 11.4748V2.9165H7.27516"
        stroke="#2E95BF"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  findDock: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 1024 1024"
      className="icon"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#000000"
          d="M800 416a288 288 0 10-576 0c0 118.144 94.528 272.128 288 456.576C705.472 688.128 800 534.144 800 416zM512 960C277.312 746.688 160 565.312 160 416a352 352 0 01704 0c0 149.312-117.312 330.688-352 544z"
        ></path>
        <path
          fill="#000000"
          d="M512 448a64 64 0 100-128 64 64 0 000 128zm0 64a128 128 0 110-256 128 128 0 010 256zm345.6 192L960 960H672v-64H352v64H64l102.4-256h691.2zm-68.928 0H235.328l-76.8 192h706.944l-76.8-192z"
        ></path>
      </g>
    </svg>
  ),
  reserveIcon: (
    <svg
      width="20"
      height="20"
      fill="#000000"
      viewBox="0 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#000000"
          d="M28 4.75h-0.75v-2.75c0-0.69-0.56-1.25-1.25-1.25s-1.25 0.56-1.25 1.25v0 2.75h-17.5v-2.75c0-0.69-0.56-1.25-1.25-1.25s-1.25 0.56-1.25 1.25v0 2.75h-0.75c-1.794 0.002-3.248 1.456-3.25 3.25v19.998c0.002 1.794 1.456 3.248 3.25 3.25h24c1.794-0.001 3.249-1.456 3.25-3.25v-19.998c-0.002-1.794-1.456-3.248-3.25-3.25h-0zM4 7.25h24c0.414 0 0.75 0.336 0.75 0.75v2.75h-25.5v-2.75c0.001-0.414 0.336-0.749 0.75-0.75h0zM28 28.748h-24c-0.414-0-0.75-0.336-0.75-0.75v-14.748h25.5v14.748c-0 0.414-0.336 0.75-0.75 0.75v0zM19.57 16.682l-5.86 6.405-1.323-1.313c-0.226-0.223-0.536-0.361-0.878-0.361-0.69 0-1.25 0.56-1.25 1.25 0 0.345 0.14 0.658 0.366 0.884v0l2.247 2.23 0.022 0.015 0.015 0.021c0.074 0.061 0.159 0.114 0.25 0.156l0.007 0.003c0.037 0.026 0.079 0.053 0.123 0.077l0.007 0.003c0.135 0.056 0.292 0.089 0.457 0.089 0.175 0 0.341-0.037 0.491-0.103l-0.008 0.003c0.053-0.031 0.098-0.061 0.14-0.094l-0.003 0.002c0.102-0.050 0.189-0.11 0.268-0.179l-0.001 0.001 0.015-0.023 0.020-0.014 6.738-7.365c0.203-0.221 0.328-0.518 0.328-0.844 0-0.69-0.559-1.25-1.25-1.25-0.365 0-0.693 0.156-0.921 0.405l-0.001 0.001z"
        ></path>
      </g>
    </svg>
  ),
  relaxIcon: (
    <svg
      fill="#000000"
      width="20"
      height="20"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path
              fill="#000000"
              d="M255.998,0c-9.333,0-16.9,7.567-16.9,16.9v33.8c0,9.333,7.567,16.9,16.9,16.9c9.333,0,16.9-7.567,16.9-16.9V16.9 C272.898,7.567,265.331,0,255.998,0z"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              fill="#000000"
              d="M200.348,50.018l-33.8-33.8c-6.6-6.6-17.301-6.6-23.9,0c-6.6,6.599-6.6,17.3,0,23.9l33.8,33.8c6.6,6.6,17.3,6.6,23.9,0 C206.948,67.319,206.948,56.618,200.348,50.018z"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              fill="#000000"
              d="M369.349,16.217c-6.6-6.6-17.301-6.6-23.9,0l-33.8,33.8c-6.6,6.599-6.6,17.3,0,23.9s17.3,6.6,23.9,0l33.8-33.8 C375.949,33.519,375.949,22.818,369.349,16.217z"
            ></path>
          </g>
        </g>
        <g>
          <g>
            <path
              fill="#000000"
              d="M493.604,458.299c-2.26-9.059-11.432-14.573-20.49-12.31l-49.194,12.265l-24.817-99.54 c65.423-26.498,89.454-102.812,56.967-163.82L402.173,93.682c-3.645-6.846-11.481-10.325-19.006-8.455l-127.168,31.707 L128.829,85.229c-7.526-1.878-15.361,1.611-19.006,8.455L55.925,194.895c-32.279,60.616-8.828,137.17,56.967,163.82 l-24.816,99.539l-49.194-12.265c-9.056-2.258-18.229,3.255-20.486,12.31c-2.258,9.056,3.253,18.23,12.309,20.487l131.186,32.708 c9.071,2.26,18.232-3.266,20.486-12.31c2.258-9.056-3.253-18.23-12.309-20.487l-49.194-12.265l24.82-99.549 c45.197,4.714,87.286-16.854,110.306-55.895c22.947,38.92,64.963,60.622,110.306,55.895l24.82,99.549l-49.194,12.265 c-9.056,2.258-14.568,11.431-12.309,20.487c2.258,9.055,11.428,14.568,20.486,12.31l131.186-32.708 C490.351,476.529,495.863,467.355,493.604,458.299z M137.181,331.157c-50.715-12.645-72.646-63.58-56.661-108.488l157.622,39.3 C231.237,308.7,188.315,343.913,137.181,331.157z M239.099,227.372h-0.001L95.934,191.676l37.522-70.459l105.643,26.341V227.372z M272.911,227.369l0.051-79.829l105.579-26.324l37.521,70.46L272.911,227.369z M374.814,331.157 c-50.761,12.662-93.997-22.072-100.961-69.187l157.622-39.3C447.331,267.214,425.9,318.42,374.814,331.157z"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  internet: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M14.073 11.7171C14.7594 10.5988 15.1218 9.31206 15.12 8.00001L15.12 7.99989L15.12 7.99976C15.1218 6.68771 14.7594 5.4009 14.073 4.28269L14.0691 4.27658C13.4323 3.23873 12.54 2.3815 11.4775 1.78682C10.415 1.19215 9.21766 0.879888 8.00003 0.879883C6.7824 0.879878 5.58511 1.19213 4.52256 1.7868C3.46002 2.38146 2.56772 3.23868 1.93094 4.27654L1.92699 4.28272C1.24232 5.4017 0.88001 6.68804 0.880005 7.99987C0.88 9.31169 1.2423 10.598 1.92696 11.717L1.93098 11.7233C2.56776 12.7611 3.46006 13.6183 4.52259 14.213C5.58513 14.8076 6.78241 15.1199 8.00003 15.1199C9.21765 15.1199 10.4149 14.8076 11.4775 14.213C12.54 13.6183 13.4323 12.7611 14.069 11.7232L14.073 11.7171ZM8.9101 13.8996C8.77443 14.0305 8.61827 14.1384 8.4478 14.2189C8.30788 14.2854 8.15491 14.3199 8 14.3199C7.84509 14.3199 7.69212 14.2854 7.5522 14.2189C7.2278 14.0532 6.95011 13.8088 6.74451 13.5081C6.32461 12.9014 6.01344 12.2262 5.82489 11.5128C6.54919 11.4683 7.27423 11.4456 8.00001 11.4447C8.72547 11.4447 9.45055 11.4674 10.1752 11.5128C10.0709 11.8796 9.94052 12.2385 9.78516 12.5868C9.58058 13.0766 9.28347 13.5223 8.9101 13.8996V13.8996ZM1.69393 8.39989H4.56577C4.58446 9.20124 4.67132 9.99954 4.8254 10.7862C4.04036 10.8552 3.25731 10.9501 2.47627 11.0708C2.01891 10.2503 1.75156 9.33752 1.69393 8.39989ZM2.47627 4.92897C3.257 5.04995 4.04032 5.14486 4.82623 5.21368C4.67184 6.00024 4.58479 6.79853 4.56602 7.59989H1.69393C1.75155 6.66226 2.01891 5.74952 2.47626 4.92897H2.47627ZM7.0899 2.10015C7.22557 1.96923 7.38173 1.86138 7.5522 1.78085C7.69212 1.71437 7.84509 1.67987 8 1.67987C8.15491 1.67987 8.30788 1.71437 8.4478 1.78085C8.7722 1.94655 9.04989 2.19092 9.25549 2.49162C9.67539 3.09838 9.98656 3.77354 10.1751 4.48693C9.4508 4.5315 8.72577 4.5542 8.00001 4.55504C7.27454 4.55503 6.54946 4.53232 5.82476 4.48692C5.92913 4.12013 6.05948 3.76124 6.21485 3.41297C6.41942 2.92318 6.71653 2.47743 7.0899 2.10015ZM14.3061 7.59989H11.4342C11.4155 6.79854 11.3287 6.00023 11.1746 5.21361C11.9597 5.14453 12.7427 5.04964 13.5237 4.92897C13.9811 5.74951 14.2485 6.66225 14.3061 7.59989ZM5.63002 10.724C5.47357 9.95859 5.38521 9.18086 5.36597 8.39989H10.6341C10.6151 9.18085 10.5269 9.95859 10.3706 10.724C9.58124 10.6722 8.79105 10.6458 8.00001 10.6447C7.20953 10.6447 6.41953 10.6711 5.63002 10.724ZM10.37 5.2758C10.5264 6.04118 10.6148 6.81892 10.634 7.59989H5.36588C5.38494 6.81892 5.47314 6.04117 5.62945 5.27576C6.41876 5.32755 7.20895 5.35397 8.00001 5.35503C8.79048 5.35503 9.58048 5.32862 10.37 5.2758V5.2758ZM11.434 8.39989H14.3061C14.2485 9.33752 13.9811 10.2503 13.5237 11.0708C12.743 10.9498 11.9597 10.8549 11.1738 10.7861C11.3282 9.99953 11.4152 9.20124 11.434 8.39989ZM13.0441 4.19265C12.3615 4.29114 11.6768 4.36911 10.9901 4.42657C10.8667 3.96706 10.7075 3.51792 10.514 3.08324C10.3374 2.68323 10.1151 2.30498 9.85166 1.95599C11.1249 2.34648 12.2422 3.12929 13.0441 4.19265ZM3.53107 3.53095C4.26146 2.79987 5.16003 2.25911 6.14801 1.95609C6.13302 1.9755 6.1176 1.99405 6.10283 2.01387C5.59501 2.74491 5.2251 3.56262 5.01137 4.42669C4.32463 4.36853 3.63949 4.29051 2.95594 4.19265C3.13223 3.95914 3.32439 3.73805 3.53107 3.53095ZM2.95593 11.8071C3.63854 11.7086 4.32319 11.6306 5.0099 11.5732C5.13332 12.0327 5.29249 12.4819 5.48597 12.9165C5.66262 13.3165 5.88488 13.6948 6.14834 14.0438C4.87509 13.6533 3.75777 12.8705 2.95593 11.8071V11.8071ZM12.4689 12.4688C11.7386 13.1999 10.84 13.7407 9.85199 14.0437C9.86698 14.0243 9.88239 14.0057 9.89717 13.9859C10.405 13.2549 10.7749 12.4371 10.9886 11.5731C11.6754 11.6312 12.3605 11.7093 13.0441 11.8071C12.8678 12.0406 12.6756 12.2617 12.4689 12.4688V12.4688Z"
        fill="#051036"
      />
    </svg>
  ),
  facebook: (
    <svg width="9" height="15" viewBox="0 0 9 15" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.62891 8.31543L8.01172 5.7998H5.57812V4.15918C5.57812 3.44824 5.90625 2.79199 7 2.79199H8.12109V0.631836C8.12109 0.631836 7.10938 0.44043 6.15234 0.44043C4.15625 0.44043 2.84375 1.6709 2.84375 3.8584V5.7998H0.601562V8.31543H2.84375V14.4404H5.57812V8.31543H7.62891Z"
        fill="#051036"
      />
    </svg>
  ),
  twitter: (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.5508 3.59668C13.0977 3.18652 13.5898 2.69434 13.9727 2.12012C13.4805 2.33887 12.9062 2.50293 12.332 2.55762C12.9336 2.20215 13.3711 1.65527 13.5898 0.97168C13.043 1.2998 12.4141 1.5459 11.7852 1.68262C11.2383 1.1084 10.5 0.780273 9.67969 0.780273C8.09375 0.780273 6.80859 2.06543 6.80859 3.65137C6.80859 3.87012 6.83594 4.08887 6.89062 4.30762C4.51172 4.1709 2.37891 3.02246 0.957031 1.2998C0.710938 1.70996 0.574219 2.20215 0.574219 2.74902C0.574219 3.7334 1.06641 4.6084 1.85938 5.12793C1.39453 5.10059 0.929688 4.99121 0.546875 4.77246V4.7998C0.546875 6.19434 1.53125 7.34277 2.84375 7.61621C2.625 7.6709 2.35156 7.72559 2.10547 7.72559C1.91406 7.72559 1.75 7.69824 1.55859 7.6709C1.91406 8.81934 2.98047 9.63965 4.23828 9.66699C3.25391 10.4326 2.02344 10.8975 0.683594 10.8975C0.4375 10.8975 0.21875 10.8701 0 10.8428C1.25781 11.6631 2.76172 12.1279 4.40234 12.1279C9.67969 12.1279 12.5508 7.78027 12.5508 3.97949C12.5508 3.84277 12.5508 3.7334 12.5508 3.59668Z"
        fill="#051036"
      />
    </svg>
  ),
  instagram: (
    <svg width="14" height="13" viewBox="0 0 14 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.125 3.2959C5.375 3.2959 3.98047 4.71777 3.98047 6.44043C3.98047 8.19043 5.375 9.58496 7.125 9.58496C8.84766 9.58496 10.2695 8.19043 10.2695 6.44043C10.2695 4.71777 8.84766 3.2959 7.125 3.2959ZM7.125 8.49121C6.00391 8.49121 5.07422 7.58887 5.07422 6.44043C5.07422 5.31934 5.97656 4.41699 7.125 4.41699C8.24609 4.41699 9.14844 5.31934 9.14844 6.44043C9.14844 7.58887 8.24609 8.49121 7.125 8.49121ZM11.1172 3.18652C11.1172 2.77637 10.7891 2.44824 10.3789 2.44824C9.96875 2.44824 9.64062 2.77637 9.64062 3.18652C9.64062 3.59668 9.96875 3.9248 10.3789 3.9248C10.7891 3.9248 11.1172 3.59668 11.1172 3.18652ZM13.1953 3.9248C13.1406 2.94043 12.9219 2.06543 12.2109 1.35449C11.5 0.643555 10.625 0.424805 9.64062 0.370117C8.62891 0.31543 5.59375 0.31543 4.58203 0.370117C3.59766 0.424805 2.75 0.643555 2.01172 1.35449C1.30078 2.06543 1.08203 2.94043 1.02734 3.9248C0.972656 4.93652 0.972656 7.97168 1.02734 8.9834C1.08203 9.96777 1.30078 10.8154 2.01172 11.5537C2.75 12.2646 3.59766 12.4834 4.58203 12.5381C5.59375 12.5928 8.62891 12.5928 9.64062 12.5381C10.625 12.4834 11.5 12.2646 12.2109 11.5537C12.9219 10.8154 13.1406 9.96777 13.1953 8.9834C13.25 7.97168 13.25 4.93652 13.1953 3.9248ZM11.8828 10.0498C11.6914 10.5967 11.2539 11.0498 10.7344 11.2412C9.91406 11.5537 7.79688 11.4717 7.125 11.4717C6.42578 11.4717 4.30859 11.5537 3.51562 11.2412C2.96875 11.0498 2.51562 10.5967 2.32422 10.0498C2.01172 9.22949 2.09375 7.11230 2.09375 6.44043C2.09375 5.74121 2.01172 3.62402 2.32422 2.83105C2.51562 2.28418 2.96875 1.83105 3.51562 1.63965C4.30859 1.32715 6.42578 1.40918 7.125 1.40918C7.79688 1.40918 9.91406 1.32715 10.7344 1.63965C11.2539 1.83105 11.7344 2.28418 11.8984 2.83105C12.2109 3.62402 12.1289 5.74121 12.1289 6.44043C12.1289 7.11230 12.2109 9.22949 11.8828 10.0498Z"
        fill="#051036"
      />
    </svg>
  ),
  heart: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        stroke="currentColor"
        strokeWidth="2"
        fill="none"
      />
    </svg>
  ),
  heartFilled: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"
        fill="currentColor"
      />
    </svg>
  ),
  youtube: (
    <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 20.5C13.8097 20.5 15.5451 20.3212 17.1534 19.9934C19.1623 19.5839 20.1668 19.3791 21.0834 18.2006C22 17.0221 22 15.6693 22 12.9635V11.0365C22 8.33073 22 6.97787 21.0834 5.79937C20.1668 4.62088 19.1623 4.41613 17.1534 4.00662C15.5451 3.67877 13.8097 3.5 12 3.5C10.1903 3.5 8.45489 3.67877 6.84656 4.00662C4.83766 4.41613 3.83321 4.62088 2.9166 5.79937C2 6.97787 2 8.33073 2 11.0365V12.9635C2 15.6693 2 17.0221 2.9166 18.2006C3.83321 19.3791 4.83766 19.5839 6.84656 19.9934C8.45489 20.3212 10.1903 20.5 12 20.5Z"
        stroke="#2A353D"
        strokeWidth="1.5"
      />
      <path
        d="M15.9621 12.3129C15.8137 12.9187 15.0241 13.3538 13.4449 14.2241C11.7272 15.1705 10.8684 15.6438 10.1728 15.4615C9.9372 15.3997 9.7202 15.2911 9.53799 15.1438C9 14.7089 9 13.8059 9 12C9 10.1941 9 9.29112 9.53799 8.85618C9.7202 8.70886 9.9372 8.60029 10.1728 8.53854C10.8684 8.35621 11.7272 8.82945 13.4449 9.77593C15.0241 10.6462 15.8137 11.0813 15.9621 11.6871C16.0126 11.8933 16.0126 12.1067 15.9621 12.3129Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  ),
  linkedin: (
    <svg width="13" height="13" viewBox="0 0 13 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M2.73438 12.6904V4.51465H0.191406V12.6904H2.73438ZM1.44922 3.4209C2.26953 3.4209 2.92578 2.7373 2.92578 1.91699C2.92578 1.12402 2.26953 0.467773 1.44922 0.467773C0.65625 0.467773 0 1.12402 0 1.91699C0 2.7373 0.65625 3.4209 1.44922 3.4209ZM12.2227 12.6904H12.25V8.20605C12.25 6.01855 11.7578 4.32324 9.1875 4.32324C7.95703 4.32324 7.13672 5.00684 6.78125 5.63574H6.75391V4.51465H4.32031V12.6904H6.86328V8.64355C6.86328 7.57715 7.05469 6.56543 8.36719 6.56543C9.67969 6.56543 9.70703 7.76855 9.70703 8.72559V12.6904H12.2227Z"
        fill="#051036"
      />
    </svg>
  ),
  checkCircle: (
    <svg width="13" height="13" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" fill="none">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#000000"
          fillRule="evenodd"
          d="M3 10a7 7 0 019.307-6.611 1 1 0 00.658-1.889 9 9 0 105.98 7.501 1 1 0 00-1.988.22A7 7 0 113 10zm14.75-5.338a1 1 0 00-1.5-1.324l-6.435 7.28-3.183-2.593a1 1 0 00-1.264 1.55l3.929 3.2a1 1 0 001.38-.113l7.072-8z"
        ></path>
      </g>
    </svg>
  ),
  upload: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  uploadSquare: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        {' '}
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 1.25C12.2189 1.25 12.427 1.34567 12.5694 1.51191L15.5694 5.01191C15.839 5.3264 15.8026 5.79988 15.4881 6.06944C15.1736 6.33901 14.7001 6.30259 14.4306 5.98809L12.75 4.02744L12.75 15C12.75 15.4142 12.4142 15.75 12 15.75C11.5858 15.75 11.25 15.4142 11.25 15L11.25 4.02744L9.56944 5.98809C9.29988 6.30259 8.8264 6.33901 8.51191 6.06944C8.19741 5.79988 8.16099 5.3264 8.43056 5.01191L11.4306 1.51191C11.573 1.34567 11.7811 1.25 12 1.25ZM6.99583 8.25196C7.41003 8.24966 7.74768 8.58357 7.74999 8.99778C7.7523 9.41198 7.41838 9.74963 7.00418 9.75194C5.91068 9.75803 5.1356 9.78642 4.54735 9.89448C3.98054 9.99859 3.65246 10.1658 3.40901 10.4092C3.13225 10.686 2.9518 11.0746 2.85315 11.8083C2.75159 12.5637 2.75 13.5648 2.75 15.0002V16.0002C2.75 17.4356 2.75159 18.4367 2.85315 19.1921C2.9518 19.9259 3.13225 20.3144 3.40901 20.5912C3.68577 20.868 4.07434 21.0484 4.80812 21.1471C5.56347 21.2486 6.56458 21.2502 8 21.2502H16C17.4354 21.2502 18.4365 21.2486 19.1919 21.1471C19.9257 21.0484 20.3142 20.868 20.591 20.5912C20.8678 20.3144 21.0482 19.9259 21.1469 19.1921C21.2484 18.4367 21.25 17.4356 21.25 16.0002V15.0002C21.25 13.5648 21.2484 12.5637 21.1469 11.8083C21.0482 11.0746 20.8678 10.686 20.591 10.4092C20.3475 10.1658 20.0195 9.99859 19.4527 9.89448C18.8644 9.78642 18.0893 9.75803 16.9958 9.75194C16.5816 9.74963 16.2477 9.41198 16.25 8.99778C16.2523 8.58357 16.59 8.24966 17.0042 8.25196C18.0857 8.25798 18.9871 8.28387 19.7236 8.41916C20.4816 8.55839 21.1267 8.82363 21.6517 9.34856C22.2536 9.95048 22.5125 10.7084 22.6335 11.6085C22.75 12.4754 22.75 13.5778 22.75 14.9453V16.0551C22.75 17.4227 22.75 18.525 22.6335 19.392C22.5125 20.2921 22.2536 21.0499 21.6517 21.6519C21.0497 22.2538 20.2919 22.5127 19.3918 22.6337C18.5248 22.7503 17.4225 22.7502 16.0549 22.7502H7.94513C6.57754 22.7502 5.47522 22.7503 4.60825 22.6337C3.70814 22.5127 2.95027 22.2538 2.34835 21.6519C1.74643 21.0499 1.48754 20.2921 1.36652 19.392C1.24996 18.525 1.24998 17.4227 1.25 16.0551V14.9453C1.24998 13.5777 1.24996 12.4754 1.36652 11.6085C1.48754 10.7084 1.74643 9.95048 2.34835 9.34856C2.87328 8.82363 3.51835 8.55839 4.27635 8.41916C5.01291 8.28386 5.9143 8.25798 6.99583 8.25196Z"
          fill="#000000"
        ></path>{' '}
      </g>
    </svg>
  ),
  map: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M9 20L3 17V4L9 7M9 20L15 17M9 20V7M15 17L21 20V7L15 4M15 17V4M9 7L15 4"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  ),
  grid: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <title></title>
        <g id="Complete">
          <g id="grid">
            <g>
              <rect
                fill="none"
                height="7"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                width="7"
                x="14.5"
                y="2.5"
              ></rect>
              <rect
                fill="none"
                height="7"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                width="7"
                x="14.5"
                y="14.5"
              ></rect>
              <rect
                fill="none"
                height="7"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                width="7"
                x="2.5"
                y="2.5"
              ></rect>
              <rect
                fill="none"
                height="7"
                stroke="#000000"
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                width="7"
                x="2.5"
                y="14.5"
              ></rect>
            </g>
          </g>
        </g>
      </g>
    </svg>
  ),
  eye: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_15_200)">
        <rect width="24" height="24" fill="white" />
        <circle cx="12" cy="13" r="2" stroke="#000000" strokeLinejoin="round" />
        <path
          d="M12 7.5C7.69517 7.5 4.47617 11.0833 3.39473 12.4653C3.14595 12.7832 3.14595 13.2168 3.39473 13.5347C4.47617 14.9167 7.69517 18.5 12 18.5C16.3048 18.5 19.5238 14.9167 20.6053 13.5347C20.8541 13.2168 20.8541 12.7832 20.6053 12.4653C19.5238 11.0833 16.3048 7.5 12 7.5Z"
          stroke="#000000"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <defs>
        <clipPath id="clip0_15_200">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),
  deleteIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5 5.5L18.8803 15.5251C18.7219 18.0864 18.6428 19.3671 18.0008 20.2879C17.6833 20.7431 17.2747 21.1273 16.8007 21.416C15.8421 22 14.559 22 11.9927 22C9.42312 22 8.1383 22 7.17905 21.4149C6.7048 21.1257 6.296 20.7408 5.97868 20.2848C5.33688 19.3626 5.25945 18.0801 5.10461 15.5152L4.5 5.5"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M21 5.5H3" stroke="#2A353D" strokeWidth="1.5" strokeLinecap="round" />
      <path
        d="M16.0555 5.5L15.3729 4.09173C14.9194 3.15626 14.6926 2.68852 14.3015 2.39681C14.2148 2.3321 14.1229 2.27454 14.0268 2.2247C13.5937 2 13.0739 2 12.0343 2C10.9686 2 10.4358 2 9.99549 2.23412C9.89791 2.28601 9.80479 2.3459 9.71711 2.41317C9.32145 2.7167 9.10044 3.20155 8.65842 4.17126L8.05273 5.5"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
      />
      <path d="M9.5 16.5L9.5 10.5" stroke="#2A353D" strokeWidth="1.5" strokeLinecap="round" />
      <path d="M14.5 16.5L14.5 10.5" stroke="#2A353D" strokeWidth="1.5" strokeLinecap="round" />
    </svg>
  ),
  blankCircle: (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.375 0.5C23.1157 0.5 27.6623 2.38325 31.0145 5.73547C34.3667 9.08768 36.25 13.6343 36.25 18.375C36.25 23.1157 34.3667 27.6623 31.0145 31.0145C27.6623 34.3667 23.1157 36.25 18.375 36.25C13.6343 36.25 9.08768 34.3667 5.73547 31.0145C2.38325 27.6623 0.5 23.1157 0.5 18.375C0.5 13.6343 2.38325 9.08768 5.73547 5.73547C9.08768 2.38325 13.6343 0.5 18.375 0.5Z"
        fill="white"
        stroke="#333333"
      />
    </svg>
  ),
  greenCircle: (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.375 0C23.2484 0 27.9221 1.93593 31.3681 5.38191C34.8141 8.82789 36.75 13.5016 36.75 18.375C36.75 23.2484 34.8141 27.9221 31.3681 31.3681C27.9221 34.8141 23.2484 36.75 18.375 36.75C13.5016 36.75 8.82789 34.8141 5.38191 31.3681C1.93593 27.9221 0 23.2484 0 18.375C0 13.5016 1.93593 8.82789 5.38191 5.38191C8.82789 1.93593 13.5016 0 18.375 0ZM16.086 22.0001L12.0041 17.9156C11.8578 17.7693 11.6841 17.6532 11.4929 17.574C11.3017 17.4948 11.0968 17.4541 10.8898 17.4541C10.6829 17.4541 10.4779 17.4948 10.2868 17.574C10.0956 17.6532 9.92183 17.7693 9.7755 17.9156C9.47997 18.2112 9.31394 18.612 9.31394 19.0299C9.31394 19.4479 9.47997 19.8487 9.7755 20.1442L14.973 25.3418C15.1189 25.4888 15.2925 25.6055 15.4838 25.6852C15.675 25.7649 15.8801 25.8059 16.0873 25.8059C16.2945 25.8059 16.4996 25.7649 16.6909 25.6852C16.8821 25.6055 17.0557 25.4888 17.2016 25.3418L27.9641 14.5766C28.1124 14.4309 28.2304 14.2573 28.3112 14.0657C28.3921 13.8742 28.4342 13.6685 28.4352 13.4606C28.4361 13.2527 28.3959 13.0467 28.3169 12.8544C28.2378 12.6621 28.1215 12.4873 27.9745 12.3402C27.8276 12.1931 27.653 12.0766 27.4608 11.9973C27.2686 11.918 27.0626 11.8776 26.8547 11.8783C26.6468 11.879 26.4411 11.9209 26.2495 12.0015C26.0578 12.0821 25.884 12.1999 25.7381 12.348L16.086 22.0001Z"
        fill="#0BB312"
      />
    </svg>
  ),
  greyCircle: (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.375 0C23.2484 0 27.9221 1.93593 31.3681 5.38191C34.8141 8.82789 36.75 13.5016 36.75 18.375C36.75 23.2484 34.8141 27.9221 31.3681 31.3681C27.9221 34.8141 23.2484 36.75 18.375 36.75C13.5016 36.75 8.82789 34.8141 5.38191 31.3681C1.93593 27.9221 0 23.2484 0 18.375C0 13.5016 1.93593 8.82789 5.38191 5.38191C8.82789 1.93593 13.5016 0 18.375 0ZM16.086 22.0001L12.0041 17.9156C11.8578 17.7693 11.6841 17.6532 11.4929 17.574C11.3017 17.4948 11.0968 17.4541 10.8898 17.4541C10.6829 17.4541 10.4779 17.4948 10.2868 17.574C10.0956 17.6532 9.92183 17.7693 9.7755 17.9156C9.47997 18.2112 9.31394 18.612 9.31394 19.0299C9.31394 19.4479 9.47997 19.8487 9.7755 20.1442L14.973 25.3418C15.1189 25.4888 15.2925 25.6055 15.4838 25.6852C15.675 25.7649 15.8801 25.8059 16.0873 25.8059C16.2945 25.8059 16.4996 25.7649 16.6909 25.6852C16.8821 25.6055 17.0557 25.4888 17.2016 25.3418L27.9641 14.5766C28.1124 14.4309 28.2304 14.2573 28.3112 14.0657C28.3921 13.8742 28.4342 13.6685 28.4352 13.4606C28.4361 13.2527 28.3959 13.0467 28.3169 12.8544C28.2378 12.6621 28.1215 12.4873 27.9745 12.3402C27.8276 12.1931 27.653 12.0766 27.4608 11.9973C27.2686 11.918 27.0626 11.8776 26.8547 11.8783C26.6468 11.879 26.4411 11.9209 26.2495 12.0015C26.0578 12.0821 25.884 12.1999 25.7381 12.348L16.086 22.0001Z"
        fill="#dedede"
      />
    </svg>
  ),
  redCircle: (
    <svg width="37" height="37" viewBox="0 0 37 37" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M18.375 0C23.2484 0 27.9221 1.93593 31.3681 5.38191C34.8141 8.82789 36.75 13.5016 36.75 18.375C36.75 23.2484 34.8141 27.9221 31.3681 31.3681C27.9221 34.8141 23.2484 36.75 18.375 36.75C13.5016 36.75 8.82789 34.8141 5.38191 31.3681C1.93593 27.9221 0 23.2484 0 18.375C0 13.5016 1.93593 8.82789 5.38191 5.38191C8.82789 1.93593 13.5016 0 18.375 0Z"
        fill="#E10606"
      />
      <path
        d="M25 12L12 25M12 12L25 25"
        stroke="#FEFEFE"
        strokeWidth="3"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  globe: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M21 12C21 16.9706 16.9706 21 12 21M21 12C21 7.02944 16.9706 3 12 3M21 12C21 13.6569 16.9706 15 12 15C7.02944 15 3 13.6569 3 12M21 12C21 10.3431 16.9706 9 12 9C7.02944 9 3 10.3431 3 12M12 21C7.02944 21 3 16.9706 3 12M12 21C10.3431 21 9 16.9706 9 12C9 7.02944 10.3431 3 12 3M12 21C13.6569 21 15 16.9706 15 12C15 7.02944 13.6569 3 12 3M3 12C3 7.02944 7.02944 3 12 3"
          stroke="#545454"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        ></path>
      </g>
    </svg>
  ),
  leftAngle: (
    <svg
      width="32"
      height="32"
      fill="#8d8b8b"
      viewBox="-12 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#8d8b8b"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M7.28 23.28c-0.2 0-0.44-0.080-0.6-0.24l-6.44-6.44c-0.32-0.32-0.32-0.84 0-1.2l6.44-6.44c0.32-0.32 0.84-0.32 1.2 0 0.32 0.32 0.32 0.84 0 1.2l-5.8 5.84 5.84 5.84c0.32 0.32 0.32 0.84 0 1.2-0.16 0.16-0.44 0.24-0.64 0.24z"></path>
      </g>
    </svg>
  ),
  rightAngle: (
    <svg
      width="32"
      height="32"
      fill="#8d8b8b"
      viewBox="-12 0 32 32"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
      stroke="#8d8b8b"
      transform="rotate(180)"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path d="M7.28 23.28c-0.2 0-0.44-0.080-0.6-0.24l-6.44-6.44c-0.32-0.32-0.32-0.84 0-1.2l6.44-6.44c0.32-0.32 0.84-0.32 1.2 0 0.32 0.32 0.32 0.84 0 1.2l-5.8 5.84 5.84 5.84c0.32 0.32 0.32 0.84 0 1.2-0.16 0.16-0.44 0.24-0.64 0.24z"></path>
      </g>
    </svg>
  ),
  createIcon: (
    <svg width="18" height="18" viewBox="0 0 87 87" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M7.45885e-05 82.65L7.80111e-05 4.35C7.80616e-05 3.19631 0.458377 2.08987 1.27416 1.27408C2.08994 0.458302 3.19638 -2.40574e-07 4.35008 -1.90144e-07C5.50377 -1.39715e-07 6.61021 0.458302 7.42599 1.27408C8.24177 2.08987 8.70007 3.19631 8.70007 4.35L8.70007 82.65C8.70007 83.8037 8.24177 84.9101 7.42599 85.7259C6.61021 86.5417 5.50376 87 4.35007 87C3.19638 87 2.08994 86.5417 1.27416 85.7259C0.458373 84.9101 7.45381e-05 83.8037 7.45885e-05 82.65Z"
        fill="black"
      />
      <path
        d="M72.8288 59.595L85.6613 46.545C86.0832 46.1579 86.4201 45.6873 86.6505 45.1631C86.881 44.6389 87 44.0726 87 43.5C87 42.9274 86.881 42.361 86.6505 41.8369C86.4201 41.3127 86.0832 40.8421 85.6613 40.455L72.8288 27.405C72.0586 26.6514 71.0467 26.1944 69.972 26.1148C68.8974 26.0352 67.8292 26.3381 66.9563 26.97C66.4321 27.322 65.9956 27.7895 65.6802 28.3366C65.3648 28.8836 65.179 29.4957 65.137 30.1257C65.095 30.7557 65.1979 31.387 65.4379 31.9711C65.6779 32.5552 66.0485 33.0765 66.5213 33.495L72.1763 39.15L21.7163 39.15C20.5626 39.15 19.4562 39.6083 18.6404 40.4241C17.8246 41.2398 17.3663 42.3463 17.3663 43.5C17.3663 44.6537 17.8246 45.7601 18.6404 46.5759C19.4562 47.3917 20.5626 47.85 21.7163 47.85L72.1763 47.85L66.5213 53.505C66.0485 53.9235 65.6779 54.4448 65.4379 55.0289C65.1979 55.6129 65.095 56.2442 65.137 56.8743C65.179 57.5043 65.3648 58.1163 65.6802 58.6634C65.9956 59.2104 66.4321 59.6779 66.9563 60.03C67.8292 60.6619 68.8974 60.9648 69.972 60.8852C71.0467 60.8056 72.0586 60.3486 72.8288 59.595Z"
        fill="black"
      />
    </svg>
  ),
  uploadAttachment: (
    <svg width="32" height="32" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10V11H17C18.933 11 20.5 12.567 20.5 14.5C20.5 16.433 18.933 18 17 18H16C15.4477 18 15 18.4477 15 19C15 19.5523 15.4477 20 16 20H17C20.0376 20 22.5 17.5376 22.5 14.5C22.5 11.7793 20.5245 9.51997 17.9296 9.07824C17.4862 6.20213 15.0003 4 12 4C8.99974 4 6.51381 6.20213 6.07036 9.07824C3.47551 9.51997 1.5 11.7793 1.5 14.5C1.5 17.5376 3.96243 20 7 20H8C8.55228 20 9 19.5523 9 19C9 18.4477 8.55228 18 8 18H7C5.067 18 3.5 16.433 3.5 14.5C3.5 12.567 5.067 11 7 11H8V10ZM15.7071 13.2929L12.7071 10.2929C12.3166 9.90237 11.6834 9.90237 11.2929 10.2929L8.29289 13.2929C7.90237 13.6834 7.90237 14.3166 8.29289 14.7071C8.68342 15.0976 9.31658 15.0976 9.70711 14.7071L11 13.4142V19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19V13.4142L14.2929 14.7071C14.6834 15.0976 15.3166 15.0976 15.7071 14.7071C16.0976 14.3166 16.0976 13.6834 15.7071 13.2929Z"
          fill="#000000"
        ></path>
      </g>
    </svg>
  ),
  rightArrow: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1 8H15M15 8L8 1M15 8L8 15"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  leftArrow: (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M15 8H1M1 8L8 15M1 8L8 1"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),
  downArrow: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.00016 1.33337V10.6667M6.00016 10.6667L10.6668 6.00004M6.00016 10.6667L1.3335 6.00004"
        stroke="#475467"
        strokeWidth="1.33333"
        strokeLinecap="round"
        fill="none"
        strokeLinejoin="round"
      />
    </svg>
  ),
  topArrow: (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.00016 10.6666V1.33329M6.00016 1.33329L10.6668 5.99996M6.00016 1.33329L1.3335 5.99996"
        stroke="#475467"
        strokeWidth="1.33"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  stack: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19 8.04144L12 3.99999L5 8.04145V9.7735L12 13.8149L19 9.7735V8.04144ZM6.5 8.90747L12 5.73204L17.5 8.90747L12 12.0829L6.5 8.90747Z"
          fill="#1F2328"
        ></path>
        <path
          d="M19 14.1789V15.911L12 19.9524L5 15.911V14.1789L12 18.2204L19 14.1789Z"
          fill="#1F2328"
        ></path>
        <path
          d="M19 11.1765V12.9086L12 16.95L5 12.9086V11.1765L12 15.218L19 11.1765Z"
          fill="#1F2328"
        ></path>
      </g>
    </svg>
  ),
  close: (
    <svg
      width="24"
      height="24"
      viewBox="0 0 1024 1024"
      xmlns="http://www.w3.org/2000/svg"
      fill="#000000"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fill="#000000"
          d="M195.2 195.2a64 64 0 0 1 90.496 0L512 421.504 738.304 195.2a64 64 0 0 1 90.496 90.496L602.496 512 828.8 738.304a64 64 0 0 1-90.496 90.496L512 602.496 285.696 828.8a64 64 0 0 1-90.496-90.496L421.504 512 195.2 285.696a64 64 0 0 1 0-90.496z"
        ></path>
      </g>
    </svg>
  ),
  filter: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24.00 24.00"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      transform="rotate(90)"
      stroke="#000000"
      strokeWidth="1.248"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g
        id="SVGRepo_tracerCarrier"
        strokeLinecap="round"
        strokeLinejoin="round"
        stroke="#CCCCCC"
        strokeWidth="1.104"
      >
        <path fill="none" d="M5 12L5 4" stroke="#222222" strokeLinecap="round"></path>
        <path fill="none" d="M19 20L19 17" stroke="#222222" strokeLinecap="round"></path>
        <path fill="none" d="M5 20L5 16" stroke="#222222" strokeLinecap="round"></path>
        <path fill="none" d="M19 13L19 4" stroke="#222222" strokeLinecap="round"></path>
        <path fill="none" d="M12 7L12 4" stroke="#222222" strokeLinecap="round"></path>
        <path fill="none" d="M12 20L12 11" stroke="#222222" strokeLinecap="round"></path>
        <circle fill="none" cx="5" cy="14" r="2" stroke="#222222" strokeLinecap="round"></circle>
        <circle fill="none" cx="12" cy="9" r="2" stroke="#222222" strokeLinecap="round"></circle>
        <circle fill="none" cx="19" cy="15" r="2" stroke="#222222" strokeLinecap="round"></circle>
      </g>
      <g id="SVGRepo_iconCarrier">
        <path fill="none" d="M5 12L5 4" stroke="#222222" strokeLinecap="round"></path>
        <path fill="none" d="M19 20L19 17" stroke="#222222" strokeLinecap="round"></path>
        <path fill="none" d="M5 20L5 16" stroke="#222222" strokeLinecap="round"></path>
        <path fill="none" d="M19 13L19 4" stroke="#222222" strokeLinecap="round"></path>
        <path fill="none" d="M12 7L12 4" stroke="#222222" strokeLinecap="round"></path>
        <path fill="none" d="M12 20L12 11" stroke="#222222" strokeLinecap="round"></path>
        <circle fill="none" cx="5" cy="14" r="2" stroke="#222222" strokeLinecap="round"></circle>
        <circle fill="none" cx="12" cy="9" r="2" stroke="#222222" strokeLinecap="round"></circle>
        <circle fill="none" cx="19" cy="15" r="2" stroke="#222222" strokeLinecap="round"></circle>
      </g>
    </svg>
  ),
  approved: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M12 2C13.2363 2 14.2979 2.74778 14.7572 3.81569C14.9195 4.19318 15.4558 4.41531 15.8376 4.26319C16.9175 3.83284 18.1969 4.05474 19.0711 4.92891C19.9452 5.80308 20.1671 7.08251 19.7368 8.16243C19.5847 8.54417 19.8068 9.08046 20.1843 9.24282C21.2522 9.70213 22 10.7637 22 12C22 13.2363 21.2522 14.2979 20.1843 14.7572C19.8068 14.9195 19.5847 15.4558 19.7368 15.8375C20.1671 16.9175 19.9453 18.1969 19.0711 19.0711C18.1969 19.9453 16.9175 20.1672 15.8376 19.7368C15.4558 19.5847 14.9195 19.8068 14.7572 20.1843C14.2979 21.2522 13.2363 22 12 22C10.7637 22 9.70214 21.2522 9.24282 20.1843C9.08046 19.8068 8.54416 19.5847 8.16243 19.7368C7.08251 20.1671 5.80308 19.9452 4.92891 19.0711C4.05474 18.1969 3.83284 16.9175 4.26319 15.8375C4.41531 15.4558 4.19318 14.9195 3.81569 14.7572C2.74777 14.2979 2 13.2363 2 12C2 10.7637 2.74778 9.70214 3.8157 9.24282C4.1932 9.08046 4.41534 8.54419 4.26321 8.16246C3.83286 7.08254 4.05477 5.80311 4.92894 4.92894C5.80311 4.05477 7.08254 3.83286 8.16246 4.26321C8.54419 4.41534 9.08046 4.1932 9.24282 3.8157C9.70214 2.74778 10.7637 2 12 2Z"
          fill="#0A8EFF"
        ></path>
        <path
          d="M8 12.5L10.5 15L16 9.5"
          stroke="#ffffff"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  searchIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17.5 17.5L22 22"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20C15.9706 20 20 15.9706 20 11Z"
        stroke="#2A353D"
        strokeWidth="1.5"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  dotMenu: (
    <svg
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <path
          d="M13 5C13 4.44772 12.5523 4 12 4C11.4477 4 11 4.44772 11 5C11 5.55228 11.4477 6 12 6C12.5523 6 13 5.55228 13 5Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
        <path
          d="M13 12C13 11.4477 12.5523 11 12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
        <path
          d="M13 19C13 18.4477 12.5523 18 12 18C11.4477 18 11 18.4477 11 19C11 19.5523 11.4477 20 12 20C12.5523 20 13 19.5523 13 19Z"
          stroke="#000000"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        ></path>
      </g>
    </svg>
  ),
  instantBooking: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M5.22576 11.3294L12.224 2.34651C12.7713 1.64397 13.7972 2.08124 13.7972 3.01707V9.96994C13.7972 10.5305 14.1995 10.985 14.6958 10.985H18.0996C18.8729 10.985 19.2851 12.0149 18.7742 12.6706L11.776 21.6535C11.2287 22.356 10.2028 21.9188 10.2028 20.9829V14.0301C10.2028 13.4695 9.80048 13.015 9.3042 13.015H5.90035C5.12711 13.015 4.71494 11.9851 5.22576 11.3294Z"
        stroke="#fff"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  ),

  error: (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1"
      strokeLinecap="round"
      strokeLinejoin="arcs"
    >
      <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z"></path>
      <line x1="12" y1="9" x2="12" y2="13"></line>
      <line x1="12" y1="17" x2="12.01" y2="17"></line>
    </svg>
  ),

  phoneIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M6.62 10.79C8.06 13.91 10.91 16.76 14.03 18.2L16.85 15.38C17.08 15.15 17.42 15.07 17.72 15.15C18.85 15.45 20.05 15.61 21.28 15.61C21.7 15.61 22 15.91 22 16.33V21C22 21.55 21.55 22 21 22C10.51 22 2 13.49 2 3C2 2.45 2.45 2 3 2H7.67C8.09 2 8.39 2.3 8.39 2.72C8.39 3.95 8.55 5.15 8.85 6.28C8.93 6.58 8.85 6.92 8.62 7.15L5.8 9.97C5.9 10.24 6.05 10.51 6.22 10.79H6.62Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  mailIcon: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M4 4H20C21.1 4 22 4.9 22 6V18C22 19.1 21.1 20 20 20H4C2.9 20 2 19.1 2 18V6C2 4.9 2.9 4 4 4Z"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M22 6L12 13L2 6"
        stroke="white"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  locationSearch: (
    <svg
      width="24"
      height="24"
      fill="#000000"
      version="1.1"
      id="Layer_1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 512 512"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <g>
            <path d="M256.845,123.489c-26.413,0-47.903,21.488-47.903,47.902c0,26.413,21.488,47.903,47.903,47.903 c26.413,0,47.903-21.489,47.903-47.903C304.747,144.977,283.258,123.489,256.845,123.489z M256.846,203.652 c-17.79,0-32.261-14.473-32.261-32.261s14.472-32.261,32.261-32.261c17.789,0,32.261,14.472,32.261,32.261 C289.107,189.179,274.634,203.652,256.846,203.652z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M353.04,283.816c-13.152,0-23.853,10.701-23.853,23.853s10.701,23.853,23.853,23.853s23.853-10.701,23.853-23.853 S366.193,283.816,353.04,283.816z M353.04,315.88c-4.528,0-8.212-3.684-8.212-8.212s3.684-8.212,8.212-8.212 s8.212,3.684,8.212,8.212C361.252,312.197,357.568,315.88,353.04,315.88z"></path>
          </g>
        </g>
        <g>
          <g>
            <path d="M160.648,283.815c-13.152,0-23.853,10.701-23.853,23.853c0,13.154,10.701,23.853,23.853,23.853 c13.154,0.001,23.854-10.7,23.854-23.853C184.503,294.516,173.802,283.815,160.648,283.815z M160.649,315.88 c-4.529,0.001-8.212-3.683-8.212-8.212c0-4.528,3.684-8.212,8.212-8.212c4.529,0,8.213,3.684,8.213,8.212 C168.862,312.197,165.178,315.88,160.649,315.88z"></path>
          </g>
        </g>
        <g>
          <g>
            <rect x="225.238" y="235.353" width="15.642" height="15.642"></rect>
          </g>
        </g>
        <g>
          <g>
            <rect x="248.179" y="235.353" width="16.684" height="15.642"></rect>
          </g>
        </g>
        <g>
          <g>
            <rect x="273.206" y="235.353" width="15.642" height="15.642"></rect>
          </g>
        </g>
        <g>
          <g>
            <path d="M429.708,274.981H388.01c-8.748-9.353-21.184-15.214-34.97-15.214c-13.786,0-26.221,5.861-34.969,15.214h-4.509 c20.415-38.218,39.283-79.936,39.283-103.589c0-52.935-43.065-96-96-96c-52.935,0-96.001,43.065-96.001,96 c0,23.653,18.868,65.371,39.283,103.589h-4.508c-8.748-9.353-21.184-15.214-34.97-15.214c-13.785,0-26.221,5.861-34.969,15.214 H84.03L0,417.767v18.842h512v-18.803L429.708,274.981z M353.04,275.408c17.789,0,32.261,14.472,32.261,32.261 c0,12.409-17.778,43.827-32.261,66.101c-14.482-22.274-32.261-53.692-32.261-66.101C320.78,289.88,335.252,275.408,353.04,275.408 z M176.486,171.391c0-44.309,36.049-80.359,80.359-80.359s80.359,36.049,80.359,80.359c0,27.389-32.532,89.435-59.772,135.915 h-41.175C209.018,260.825,176.486,198.78,176.486,171.391z M268.121,322.948c-4.056,6.709-7.867,12.874-11.276,18.292 c-3.41-5.418-7.22-11.583-11.277-18.292H268.121z M160.649,275.408c17.789,0,32.261,14.472,32.261,32.261 c0,12.409-17.778,43.827-32.261,66.101c-14.482-22.274-32.26-53.692-32.26-66.101C128.388,289.88,142.859,275.408,160.649,275.408 z M16.265,420.968l76.709-130.346h22.918c-2.025,5.3-3.146,11.044-3.146,17.047c0,23.886,37.223,78.464,41.468,84.608l6.435,9.316 l6.435-9.316c4.244-6.144,41.468-60.723,41.468-84.608c0-6.003-1.12-11.747-3.146-17.047h3.148v-0.199 c20.422,36.688,40.028,66.983,41.733,69.606l6.558,10.09l6.557-10.09c1.702-2.618,21.24-32.809,41.622-69.407h3.261 c-2.025,5.3-3.146,11.044-3.146,17.047c0,23.886,37.223,78.464,41.468,84.608l6.435,9.316l6.435-9.316 c4.244-6.144,41.468-60.723,41.468-84.608c0-6.003-1.12-11.747-3.146-17.047h22.87l75.101,130.346H16.265z"></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  keywordSearch: (
    <svg
      width="24"
      height="24"
      fill="#000000"
      viewBox="0 0 512 512"
      enableBackground="new 0 0 512 512"
      id="Keyword_x5F_find"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g>
          <path d="M388.517,407.855c-3.741,0-6.774,3.034-6.774,6.775v14.039c0,18.449-15.01,33.459-33.459,33.459H106.978 c7.942-7.175,14.027-17.469,14.027-31.648v-66.248c0-3.742-3.033-6.774-6.774-6.774c-3.741,0-6.774,3.032-6.774,6.774v66.248 c0,26.054-29.251,31.527-30.477,31.745c-0.2,0.034-0.384,0.104-0.577,0.155c-0.557-0.148-1.131-0.252-1.734-0.252 c-14.471,0-26.244-11.773-26.244-26.244v-44.238h36.58c3.741,0,6.774-3.033,6.774-6.774s-3.033-6.774-6.774-6.774H41.65 c-3.741,0-6.774,3.033-6.774,6.774v51.013c0,21.942,17.851,39.793,39.792,39.793c0.601,0,1.172-0.104,1.727-0.25 c0.555,0.146,1.125,0.25,1.724,0.25h270.164c25.92,0,47.008-21.088,47.008-47.008v-14.039 C395.291,410.89,392.258,407.855,388.517,407.855z"></path>
          <path d="M114.23,136.049c3.742,0,6.774-3.033,6.774-6.774V49.871h260.737v88.542c0,3.742,3.033,6.774,6.774,6.774 s6.774-3.033,6.774-6.774V43.097c0-3.741-3.033-6.774-6.774-6.774H114.23c-3.741,0-6.774,3.033-6.774,6.774v86.178 C107.457,133.017,110.489,136.049,114.23,136.049z"></path>
          <path d="M241.122,93.065c-3.742,0-6.774,3.033-6.774,6.774c0,3.742,3.033,6.774,6.774,6.774h109.245 c3.742,0,6.774-3.033,6.774-6.774c0-3.741-3.032-6.774-6.774-6.774H241.122z"></path>
          <path d="M150.997,93.065c-3.741,0-6.774,3.033-6.774,6.774c0,3.742,3.033,6.774,6.774,6.774h48.424 c3.741,0,6.774-3.033,6.774-6.774c0-3.741-3.033-6.774-6.774-6.774H150.997z"></path>
          <path d="M350.367,433.662c3.742,0,6.774-3.033,6.774-6.774c0-3.74-3.032-6.774-6.774-6.774h-47.043 c-3.742,0-6.774,3.034-6.774,6.774c0,3.741,3.032,6.774,6.774,6.774H350.367z"></path>
          <path d="M144.223,426.888c0,3.741,3.033,6.774,6.774,6.774h106.326c3.741,0,6.774-3.033,6.774-6.774 c0-3.74-3.033-6.774-6.774-6.774H150.997C147.256,420.113,144.223,423.147,144.223,426.888z"></path>
          <path d="M204.115,372.178h-53.118c-3.741,0-6.774,3.032-6.774,6.773c0,3.742,3.033,6.774,6.774,6.774h53.118 c3.742,0,6.774-3.032,6.774-6.774C210.89,375.21,207.857,372.178,204.115,372.178z"></path>
          <path d="M355.844,275.283H246.322c-0.032,0-0.063,0.009-0.095,0.01c-0.249,0.003-0.491,0.043-0.736,0.074 c-0.204,0.024-0.412,0.034-0.61,0.077c-0.179,0.039-0.348,0.108-0.523,0.162c-0.248,0.075-0.499,0.14-0.734,0.241 c-0.14,0.062-0.266,0.148-0.402,0.219c-0.248,0.129-0.5,0.25-0.728,0.406c-0.161,0.11-0.3,0.249-0.451,0.373 c-0.183,0.149-0.374,0.287-0.54,0.455c-0.143,0.145-0.259,0.314-0.389,0.472c-0.15,0.183-0.31,0.355-0.44,0.554 c-0.095,0.143-0.165,0.307-0.25,0.458c-0.134,0.242-0.272,0.48-0.377,0.739c-0.011,0.027-0.028,0.049-0.039,0.076 c-1.082,2.781-2.322,5.544-3.685,8.211c-1.702,3.332-0.381,7.412,2.95,9.114c0.987,0.505,2.04,0.744,3.076,0.744 c2.464,0,4.841-1.35,6.038-3.694c0.861-1.686,1.668-3.406,2.438-5.143h105.017c3.742,0,6.774-3.033,6.774-6.775 C362.618,278.315,359.586,275.283,355.844,275.283z"></path>
          <path d="M277.896,246.49h17.817c3.742,0,6.775-3.033,6.775-6.774v-18.464c0-1.821,1.48-3.302,3.301-3.302h22.291 c1.196,0,1.981,0.611,2.344,0.976c0.361,0.365,0.968,1.156,0.958,2.353l-0.15,18.815c-0.015,1.806,0.692,3.543,1.965,4.824 c1.272,1.283,3.003,2.004,4.81,2.004h18.482c3.742,0,6.774-3.033,6.774-6.774c0-3.741-3.032-6.774-6.774-6.774h-11.654 l0.096-11.987c0.037-4.527-1.699-8.79-4.889-12.003c-3.188-3.213-7.435-4.982-11.961-4.982h-22.291 c-9.29,0-16.85,7.56-16.85,16.851v11.689h-11.044c-3.741,0-6.774,3.033-6.774,6.774C271.121,243.457,274.154,246.49,277.896,246.49 z"></path>
          <path d="M156.323,350.355c7.915,0,15.803-0.899,23.446-2.674c3.645-0.846,5.913-4.484,5.067-8.129 c-0.845-3.645-4.481-5.918-8.129-5.067c-6.641,1.54-13.498,2.322-20.384,2.322c-49.5,0-89.772-40.272-89.772-89.772 c0-49.501,40.272-89.773,89.772-89.773c11.764,0,23.197,2.238,33.98,6.653c3.464,1.418,7.419-0.242,8.836-3.703 c1.417-3.462-0.241-7.418-3.703-8.836c-12.421-5.084-25.581-7.662-39.114-7.662c-56.971,0-103.321,46.349-103.321,103.321 C53.002,304.006,99.352,350.355,156.323,350.355z"></path>
          <path d="M156.323,222.25c1.066,0,2.135,0.068,3.179,0.201c3.718,0.481,7.104-2.149,7.579-5.859 c0.475-3.711-2.148-7.104-5.859-7.579c-1.612-0.206-3.26-0.311-4.899-0.311c-21.136,0-38.333,17.196-38.333,38.333 c0,21.137,17.196,38.332,38.333,38.332c3.741,0,6.774-3.032,6.774-6.773c0-3.742-3.033-6.774-6.774-6.774 c-13.667,0-24.784-11.118-24.784-24.784C131.539,233.369,142.656,222.25,156.323,222.25z"></path>
          <path d="M469.466,392.541l-47.604-47.605c-2.646-2.645-6.936-2.645-9.581,0c-2.646,2.646-2.646,6.936,0,9.581l47.604,47.604 c4.93,4.93,4.93,12.951,0.001,17.883c-4.931,4.928-12.953,4.932-17.884,0l-63.128-63.129 c28.508-23.375,46.733-58.849,46.733-98.505c0-70.224-57.132-127.355-127.355-127.355c-70.225,0-127.356,57.132-127.356,127.355 s57.132,127.355,127.356,127.355c25.654,0,49.544-7.651,69.557-20.754l64.613,64.611c5.106,5.107,11.813,7.659,18.521,7.659 c6.707,0,13.415-2.552,18.522-7.659C479.678,419.371,479.678,402.755,469.466,392.541z M298.252,372.178 c-62.754,0-113.808-51.055-113.808-113.808s51.054-113.807,113.808-113.807c62.753,0,113.807,51.054,113.807,113.807 S361.005,372.178,298.252,372.178z"></path>
          <path d="M298.252,165.201c-51.374,0-93.169,41.795-93.169,93.169c0,51.374,41.795,93.169,93.169,93.169 c51.373,0,93.168-41.795,93.168-93.169C391.42,206.997,349.625,165.201,298.252,165.201z M298.252,337.99 c-43.902,0-79.621-35.717-79.621-79.62c0-43.903,35.718-79.62,79.621-79.62s79.619,35.717,79.619,79.62 C377.871,302.273,342.154,337.99,298.252,337.99z"></path>
          <path d="M244.6,230.667c0.125,0.648,0.218,1.286,0.326,1.928c0.425,2.627,0.745,5.276,0.936,7.941 c0.005,0.083,0.011,0.166,0.017,0.248c0.063,0.912,0.109,1.825,0.145,2.739c0.039,1.147,0.072,2.301,0.072,3.512 c0,1.603-0.059,3.225-0.144,4.835c-0.046,0.874-0.09,1.751-0.161,2.616c-0.307,3.729,2.468,7,6.196,7.307 c0.189,0.016,0.377,0.023,0.563,0.023c3.489,0,6.452-2.68,6.744-6.219c0.056-0.678,0.083-1.364,0.126-2.047 c0.007-0.079,0.031-0.152,0.036-0.232c0.015-0.237,0.009-0.476,0.021-0.713c0.099-1.855,0.167-3.716,0.167-5.57 c0-1.355-0.032-2.709-0.085-4.06c-0.035-1.023-0.096-2.029-0.159-3.021c-0.012-0.159-0.021-0.317-0.032-0.475 c-0.21-3.035-0.56-5.997-1.058-8.977c-0.126-0.78-0.253-1.56-0.396-2.336c-0.015-0.078-0.023-0.153-0.039-0.23 c-0.004-0.021-0.014-0.04-0.018-0.061c-0.619-3.303-1.389-6.574-2.328-9.798c-1.048-3.592-4.805-5.657-8.399-4.608 c-3.591,1.047-5.654,4.807-4.608,8.399C243.365,224.762,244.054,227.7,244.6,230.667z"></path>
        </g>
      </g>
    </svg>
  ),
  faqOpenIcon: (
    <svg width="14" height="2" viewBox="0 0 14 2" fill="none" xmlns="http://www.w3.org/2000/svg">
      <rect y="2" width="2" height="14" transform="rotate(-90 0 2)" fill="#051036" />
    </svg>
  ),
  faqCloseIcon: (
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M6 0H8V14H6V0Z" fill="#051036" />
      <path d="M8.74228e-08 8L0 6L14 6V8L8.74228e-08 8Z" fill="#051036" />
    </svg>
  ),
  tag: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g strokeWidth="0"></g>
      <g strokeLinecap="round" strokeLinejoin="round"></g>
      <g>
        <path
          d="M20.59 13.41L10.59 3.41A2 2 0 0 0 8.17 3.17L3.17 8.17A2 2 0 0 0 3 10.59l10 10a2 2 0 0 0 2.83 0l5-5a2 2 0 0 0 0-2.83z"
          stroke="#0000FF"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <circle cx="6.5" cy="6.5" r="1.5" stroke="#0000FF" strokeWidth="2" />
      </g>
    </svg>
  ),
  location: (
    <svg width="18" height="22" viewBox="0 0 18 22" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M9 12C10.6569 12 12 10.6569 12 9C12 7.34315 10.6569 6 9 6C7.34315 6 6 7.34315 6 9C6 10.6569 7.34315 12 9 12Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
      <path
        d="M9 21C13 17 17 13.4183 17 9C17 4.58172 13.4183 1 9 1C4.58172 1 1 4.58172 1 9C1 13.4183 5 17 9 21Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  anchor: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="12" cy="6" r="2" stroke="#000" strokeWidth="2" fill="none" />

      <line
        x1="12"
        y1="8"
        x2="12"
        y2="14"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        fill="none"
      />

      <path
        d="M5 14c1.5 3 4 5 7 5s5.5-2 7-5"
        stroke="#000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),

  starOutline: (
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 3l2.4 5.1 5.6.8-4 4 1 5.6L12 16.8 6.9 18.5l1-5.6-4-4 5.6-.8L12 3z"
        stroke="#E8B534"
        strokeWidth="2"
        strokeLinejoin="round"
        strokeLinecap="round"
      />
    </svg>
  ),
  starFilled: (
    <svg
      width="20"
      height="20"
      viewBox="0 0 24 24"
      fill="#E8B534"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M12 2.5l2.9 6.1 6.6.9-4.8 4.7 1.1 6.6L12 17.7 6.2 20.8l1.1-6.6L2.5 9.5l6.6-.9L12 2.5z" />
    </svg>
  ),
  downloadApp: (
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" className="w-4 h-4">
      <path
        fill="currentColor"
        d="M7 23q-.825 0-1.412-.587T5 21V3q0-.825.588-1.412T7 1h7v5H7v12h10v-2h2v5q0 .825-.587 1.413T17 23zm11-9l-5-5l1.4-1.4l2.6 2.6V3h2v7.2l2.6-2.6L23 9z"
      ></path>
    </svg>
  ),
  image: (
    <svg width="22" height="20" viewBox="0 0 22 20" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M3.27209 18.7279L9.86863 12.1314C10.2646 11.7354 10.4627 11.5373 10.691 11.4632C10.8918 11.3979 11.1082 11.3979 11.309 11.4632C11.5373 11.5373 11.7354 11.7354 12.1314 12.1314L18.6839 18.6839M13 13L15.8686 10.1314C16.2646 9.73535 16.4627 9.53735 16.691 9.46316C16.8918 9.3979 17.1082 9.3979 17.309 9.46316C17.5373 9.53735 17.7354 9.73535 18.1314 10.1314L21 13M9 7C9 8.10457 8.10457 9 7 9C5.89543 9 5 8.10457 5 7C5 5.89543 5.89543 5 7 5C8.10457 5 9 5.89543 9 7ZM5.8 19H16.2C17.8802 19 18.7202 19 19.362 18.673C19.9265 18.3854 20.3854 17.9265 20.673 17.362C21 16.7202 21 15.8802 21 14.2V5.8C21 4.11984 21 3.27976 20.673 2.63803C20.3854 2.07354 19.9265 1.6146 19.362 1.32698C18.7202 1 17.8802 1 16.2 1H5.8C4.11984 1 3.27976 1 2.63803 1.32698C2.07354 1.6146 1.6146 2.07354 1.32698 2.63803C1 3.27976 1 4.11984 1 5.8V14.2C1 15.8802 1 16.7202 1.32698 17.362C1.6146 17.9265 2.07354 18.3854 2.63803 18.673C3.27976 19 4.11984 19 5.8 19Z"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  verify: (
    <svg width="18" height="13" viewBox="0 0 18 13" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M17 1L6 12L1 7"
        stroke="black"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  ),
  users: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_3463_405729)">
        <path
          d="M22 21V19C22 17.1362 20.7252 15.5701 19 15.126M15.5 3.29076C16.9659 3.88415 18 5.32131 18 7C18 8.67869 16.9659 10.1159 15.5 10.7092M17 21C17 19.1362 17 18.2044 16.6955 17.4693C16.2895 16.4892 15.5108 15.7105 14.5307 15.3045C13.7956 15 12.8638 15 11 15H8C6.13623 15 5.20435 15 4.46927 15.3045C3.48915 15.7105 2.71046 16.4892 2.30448 17.4693C2 18.2044 2 19.1362 2 21M13.5 7C13.5 9.20914 11.7091 11 9.5 11C7.29086 11 5.5 9.20914 5.5 7C5.5 4.79086 7.29086 3 9.5 3C11.7091 3 13.5 4.79086 13.5 7Z"
          stroke="black"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
        />
      </g>
      <defs>
        <clipPath id="clip0_3463_405729">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  ),

  warning: (
    <svg viewBox="0 0 24 24" width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 2L22 22H2L12 2Z" fill="#FFCC00" />
      <path d="M11 7H13V13H11V7ZM11 15H13V17H11V15Z" fill="#000000" />
    </svg>
  ),
  community: (
    <svg viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g id="🔍-Product-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="ic_fluent_people_community_28_filled" fill="#212121" fillRule="nonzero">
            <path
              d="M17.75,18 C18.7164983,18 19.5,18.7835017 19.5,19.75 L19.5,21.7519766 L19.4921156,21.8604403 C19.1813607,23.9866441 17.2715225,25.0090369 14.0667905,25.0090369 C10.8736123,25.0090369 8.93330141,23.9983408 8.51446278,21.8965776 L8.5,21.75 L8.5,19.75 C8.5,18.7835017 9.28350169,18 10.25,18 L17.75,18 Z M18.2439108,11.9999135 L24.25,12 C25.2164983,12 26,12.7835017 26,13.75 L26,15.7519766 L25.9921156,15.8604403 C25.6813607,17.9866441 23.7715225,19.0090369 20.5667905,19.0090369 L20.3985759,19.007437 C20.0900029,17.9045277 19.1110503,17.0815935 17.9288034,17.0057197 L17.75,17 L16.8277704,17.0007255 C17.8477843,16.1757619 18.5,14.9140475 18.5,13.5 C18.5,12.9740145 18.4097576,12.4691063 18.2439108,11.9999135 Z M3.75,12 L9.75608915,11.9999135 C9.59024243,12.4691063 9.5,12.9740145 9.5,13.5 C9.5,14.8308682 10.0777413,16.0267978 10.996103,16.8506678 L11.1722296,17.0007255 L10.25,17 C8.9877951,17 7.92420242,17.85036 7.60086562,19.0094363 L7.5667905,19.0090369 C4.37361228,19.0090369 2.43330141,17.9983408 2.01446278,15.8965776 L2,15.75 L2,13.75 C2,12.7835017 2.78350169,12 3.75,12 Z M14,10 C15.9329966,10 17.5,11.5670034 17.5,13.5 C17.5,15.4329966 15.9329966,17 14,17 C12.0670034,17 10.5,15.4329966 10.5,13.5 C10.5,11.5670034 12.0670034,10 14,10 Z M20.5,4 C22.4329966,4 24,5.56700338 24,7.5 C24,9.43299662 22.4329966,11 20.5,11 C18.5670034,11 17,9.43299662 17,7.5 C17,5.56700338 18.5670034,4 20.5,4 Z M7.5,4 C9.43299662,4 11,5.56700338 11,7.5 C11,9.43299662 9.43299662,11 7.5,11 C5.56700338,11 4,9.43299662 4,7.5 C4,5.56700338 5.56700338,4 7.5,4 Z"
              id="🎨-Color"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),
  communityOutline: (
    <svg viewBox="0 0 28 28" version="1.1" xmlns="http://www.w3.org/2000/svg" fill="#000000">
      <g id="SVGRepo_bgCarrier" strokeWidth="0"></g>
      <g id="SVGRepo_tracerCarrier" strokeLinecap="round" strokeLinejoin="round"></g>
      <g id="SVGRepo_iconCarrier">
        <g id="🔍-Product-Icons" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
          <g id="ic_fluent_people_community_28_regular" fill="#212121" fillRule="nonzero">
            <path
              d="M17.25,18 C18.4926407,18 19.5,19.0073593 19.5,20.25 L19.5,21.7519766 L19.4921156,21.8604403 C19.1813607,23.9866441 17.2715225,25.0090369 14.0667905,25.0090369 C10.8736123,25.0090369 8.93330141,23.9983408 8.51446278,21.8965776 L8.5,21.75 L8.5,20.25 C8.5,19.0073593 9.50735931,18 10.75,18 L17.25,18 Z M17.25,19.5 L10.75,19.5 C10.3357864,19.5 10,19.8357864 10,20.25 L10,21.670373 C10.2797902,22.870787 11.550626,23.5090369 14.0667905,23.5090369 C16.582858,23.5090369 17.7966388,22.8777026 18,21.6931543 L18,20.25 C18,19.8357864 17.6642136,19.5 17.25,19.5 Z M18.2435553,11.9989081 L23.75,12 C24.9926407,12 26,13.0073593 26,14.25 L26,15.7519766 L25.9921156,15.8604403 C25.6813607,17.9866441 23.7715225,19.0090369 20.5667905,19.0090369 L20.2519278,19.0056708 L20.2519278,19.0056708 C19.9568992,18.2920884 19.4151086,17.7078172 18.7333573,17.3574924 C19.2481703,17.4584023 19.8580822,17.5090369 20.5667905,17.5090369 C23.082858,17.5090369 24.2966388,16.8777026 24.5,15.6931543 L24.5,14.25 C24.5,13.8357864 24.1642136,13.5 23.75,13.5 L18.5,13.5 C18.5,12.9736388 18.4096286,12.468385 18.2435553,11.9989081 Z M4.25,12 L9.75644465,11.9989081 C9.61805027,12.3901389 9.53222663,12.8062147 9.50746303,13.2386463 L9.5,13.5 L4.25,13.5 C3.83578644,13.5 3.5,13.8357864 3.5,14.25 L3.5,15.670373 C3.77979024,16.870787 5.05062598,17.5090369 7.5667905,17.5090369 C8.18886171,17.5090369 8.73132757,17.4704451 9.1985991,17.3944422 C8.5478391,17.7478373 8.03195873,18.3174175 7.74634871,19.0065739 L7.5667905,19.0090369 C4.37361228,19.0090369 2.43330141,17.9983408 2.01446278,15.8965776 L2,15.75 L2,14.25 C2,13.0073593 3.00735931,12 4.25,12 Z M14,10 C15.9329966,10 17.5,11.5670034 17.5,13.5 C17.5,15.4329966 15.9329966,17 14,17 C12.0670034,17 10.5,15.4329966 10.5,13.5 C10.5,11.5670034 12.0670034,10 14,10 Z M14,11.5 C12.8954305,11.5 12,12.3954305 12,13.5 C12,14.6045695 12.8954305,15.5 14,15.5 C15.1045695,15.5 16,14.6045695 16,13.5 C16,12.3954305 15.1045695,11.5 14,11.5 Z M20.5,4 C22.4329966,4 24,5.56700338 24,7.5 C24,9.43299662 22.4329966,11 20.5,11 C18.5670034,11 17,9.43299662 17,7.5 C17,5.56700338 18.5670034,4 20.5,4 Z M7.5,4 C9.43299662,4 11,5.56700338 11,7.5 C11,9.43299662 9.43299662,11 7.5,11 C5.56700338,11 4,9.43299662 4,7.5 C4,5.56700338 5.56700338,4 7.5,4 Z M20.5,5.5 C19.3954305,5.5 18.5,6.3954305 18.5,7.5 C18.5,8.6045695 19.3954305,9.5 20.5,9.5 C21.6045695,9.5 22.5,8.6045695 22.5,7.5 C22.5,6.3954305 21.6045695,5.5 20.5,5.5 Z M7.5,5.5 C6.3954305,5.5 5.5,6.3954305 5.5,7.5 C5.5,8.6045695 6.3954305,9.5 7.5,9.5 C8.6045695,9.5 9.5,8.6045695 9.5,7.5 C9.5,6.3954305 8.6045695,5.5 7.5,5.5 Z"
              id="🎨-Color"
            ></path>
          </g>
        </g>
      </g>
    </svg>
  ),

  appStoreIcon: (
    <svg
      viewBox="0 0 135 40"
      width="135"
      height="40"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <rect width="135" height="40" rx="6" fill="#000000" />
      <path
        d="M24.4 18.2c0-2.8 2.3-4.2 2.4-4.2-1.3-1.9-3.3-2.2-4.1-2.2-1.7-.2-3.4 1-4.3 1-.9 0-2.3-1-3.8-1-1.9 0-3.6 1.1-4.5 2.8-1.9 3.3-.5 8.2 1.4 10.9.9 1.3 2 2.8 3.3 2.7 1.4-.1 1.9-.9 3.5-.9 1.6 0 2.1.9 3.5.9 1.5.1 2.4-1.3 3.3-2.7 1-1.5 1.5-3 1.5-3-.1-.1-2.5-.9-2.5-3.8zm-2.3-6c.7-.9 1.3-2.2 1.1-3.5-1.1.1-2.5.7-3.3 1.6-.6.8-1.3 2.1-1.1 3.4 1.3.1 2.5-.6 3.3-1.5z"
        fill="#ffffff"
      />
      <text x="36" y="14" fill="#ffffff" style={{ font: '400 8px sans-serif' }}>
        Download on the
      </text>
      <text x="36" y="30" fill="#ffffff" style={{ font: '600 15px sans-serif' }}>
        App Store
      </text>
    </svg>
  ),

  googlePlayIcon: (
    <svg
      viewBox="0 0 135 40"
      width="135"
      height="40"
      xmlns="http://www.w3.org/2000/svg"
      style={{ display: 'block' }}
    >
      <rect width="135" height="40" rx="6" fill="#000000" />
      <g transform="translate(10, 8)">
        <path
          d="M1.3 0.6C1.1 0.8 1 1.2 1 1.8v20.4c0 .6.1 1 .3 1.2l.1.1L12.8 12v-.2L1.4.5l-.1.1z"
          fill="#00F0FF"
        />
        <path
          d="M16.6 15.8l-3.8-3.8V11.9L16.6 8.1l.1.1 4.3 2.5c1.2.7 1.2 1.8 0 2.5l-4.3 2.6-.1.1z"
          fill="#FFD100"
        />
        <path d="M12.9 12L1.4 23.5c.4.4 1.1.5 1.9.1l13.3-7.6-3.7-4z" fill="#FF3A44" />
        <path d="M12.9 12l3.7-4L3.3.4C2.5 0 1.8 0.1 1.4.5L12.9 12z" fill="#00E676" />
      </g>
      <text
        x="38"
        y="14"
        fill="#ffffff"
        style={{ font: '500 8px sans-serif', textTransform: 'uppercase' }}
      >
        GET IT ON
      </text>
      <text x="38" y="30" fill="#ffffff" style={{ font: '600 15px sans-serif' }}>
        Google Play
      </text>
    </svg>
  ),
  shoreAccess: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 18l-5-5-5 5M12 13V3M4 21h16" />
    </svg>
  ),
  restrooms: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M10 21V9a2 2 0 0 1 2-2h0a2 2 0 0 1 2 2v12M7 4h10M9 21h6" />
    </svg>
  ),
  shorePower: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M13 2L3 14h9l-1 8 10-12h-9l1-8z" />
    </svg>
  ),
  waterHookup: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M12 22a7 7 0 0 0 7-7c0-2-1-3.9-3-5.5s-4-3.5-4-3.5-2 1.9-4 3.5S5 13 5 15a7 7 0 0 0 7 7z" />
    </svg>
  ),
  parkingOnShore: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <rect x="3" y="11" width="18" height="10" rx="2" />
      <path d="M7 11V7a5 5 0 0 1 10 0v4" />
    </svg>
  ),
  eventSpace: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2M9 7a4 4 0 1 0 0-8 4 4 0 0 0 0 8zm14 14v-2a4 4 0 0 0-3-3.87M16 3.13a4 4 0 0 1 0 7.75" />
    </svg>
  ),
  wifi: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M5 12.55a11 11 0 0 1 14.08 0M1.42 9a16 16 0 0 1 21.16 0M8.53 16.11a6 6 0 0 1 6.95 0M12 20h.01" />
    </svg>
  ),
  pumpOut: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M7 7h10v10H7zM7 3v4m10-4v4M10 17v4m4-4v4" />
    </svg>
  ),
  fuelDock: (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
      <path d="M3 22V5a2 2 0 0 1 2-2h10a2 2 0 0 1 2 2v17M13 8h-6M17 10h4v4l-4 2" />
    </svg>
  ),
};

const Icons = ({ name }) => {
  return icons[name];
};

export default Icons;
